<template>
  <div :class="themeCtx">

    <div
        class="routes_composer_wrapper" :class="{flushingRoutes:flushingRoutes}"
        vxoading="loading" element-loading-text="Loading..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(115, 220, 100, 0.5)">
      <s-modal v-model="showBooking" title="Booking" @close="showBookingId=null" sizeH="94vh" :sizeW="90">
        <booking-form v-if="showBookingId" v-model="showBookingId"
                      @input="showBookingId=null;showBooking=false;loadTheBookings()"
                      style="min-height: 80vh"></booking-form>
      </s-modal>
      <div
          class="unrouted_bookings_header shadow-2"
      >
        <q-btn
            style="text-shadow: 0px 0px 3px black;"
            round
            icon="undo"
            :disable="!undoCount"
            color="orange-14"
            @click="undoMove">
          {{ undoCount || '' }}
        </q-btn>
        <transition name="slide-fade-right">
          <div xclass="text-white bg-red q-pa-xs" v-if="problems">
            <q-btn v-for="(pax,cd) in problems" :key="cd" :icon="warnIcons[cd]" color="orange" outline
                   dense xsize="sm" @click="warning_mode=!warning_mode" :title="cd+' '+pax+' issues'">
              {{ pax }}
            </q-btn>

          </div>
        </transition>
        <!--        <i-->
        <!--            class="el-icon-ship"-->
        <!--            style="color:red"-->
        <!--            @click="undoMove"></i>-->
        <q-checkbox v-if="wTripTypes==='EXCRS'"
                    :title="meetingPointPriority?'Bookings pickup point is the meeting point':'Bookings pickup point is the hotel'"
                    dark v-model="meetingPointPriority" @input="loadTheBookings()">
          <span class="material-icons" style="color:#fff5b1;">groups</span>
        </q-checkbox>

        <q-btn

            :color="autoRouting?'orange':'deep-green'"
            :glossy="autoRouting"
            tabindex="-1"
            style="padding-left: 5px;padding-right: 5px"
            :title="autoRouting?'When you create new routes or route new bookings I will do my best to put them in order':'New bookings will follow trip times or previously set time'"
            icon="route"

            @click="loadSeqPatterns">

        </q-btn>
        <q-btn
            style="padding-left: 5px;padding-right: 5px"
            :color="!publishState?'orange':'deep-green'"
            :glossy="!publishState"
            tabindex="-1"

            :title="!publishState?'Any changes you make WILL BE DISPLAYED TO THE DRIVERS':'You are working silently now'"
            icon="campaign"

            @click="togglePauseRouteReport()">

        </q-btn>
        <q-btn
            round
            color="deep-orange"
            glossy
            tabindex="-1"
            :disabled="checkedRoutes == false"
            title="remove bookings from routes"

            @click="unrouteBookings($event)">

                    <span
                        class="material-icons">remove</span>

        </q-btn>


        <q-btn
            tabindex="-1"
            type="primary"
            @click="sortData()"
            style="padding-left: 9px;padding-right: 9px;background-color: blueviolet;"
            title="Sort Routes by time">

          <span class="material-icons">sort</span>

        </q-btn>
        <q-btn
            tabindex="-1"
            type="primary"

            style="width:130px"
            :disabled="!selected_pax"
            @click="createRoute($event)"
            title="Create Route">
          <q-chip
              v-if="selected_pax"
              color="primary"
              text-color="white">
            <q-avatar>
              <i class="material-icons">supervisor_account</i>
            </q-avatar>
            {{ selected_pax }}
          </q-chip>
          <span
              class="material-icons"
              style="padding-bottom: 3px">add</span>
          <small> {{ data ? data.length : 0 }}</small> <i class="material-icons">directions_bus</i>

        </q-btn>


      </div>
      <q-spinner-gears v-if="loading||flushingRoutes" color="teal-10" size="3em"
                       style="position: fixed;top:10vh;left: 50vw;z-index: 1000"/>
      <transition name="slide-fade-up" mode="out-in">
        <el-row
            v-if="!unrouted_data?.length && !data?.length"
            style="text-align: center;padding-top: 30vh;padding-left: 30vw">
          <!--          <q-spinner-gears color="teal-10" size="3em"/>-->
          <h3 v-if="!loading&&!flushingRoutes">..loading....</h3>
        </el-row>
        <div class="bookings_composer_main_section" v-else>
          <div
              v-fill-height="{container:'row',noStyles:true}"
              :style="'overflow:auto;'+(filteredRoutes?.length?'max-width:50%':'width: 100%;')"
              class="unrouted_bookings_container"
              v-if="unrouted_data != null"
          ><!--- v-fill-height="{noStyles:columns?.length<5}" -->
            <div class="q-pa-md">
              <q-table
                  :key="clock"
                  :loading="loading"
                  row-key="id"
                  dark
                  :data="unrouted_data"
                  :columns="columns"
                  color="primary"
                  separator="cell"
                  class="unrouted"
                  :pagination.sync="pagination"
                  hide-pagination
                  :sort-method="rowDataSorter">
                <template v-slot:loading>
                  <q-inner-loading
                      showing
                      color="primary"/>
                </template>

                <template v-slot:header="props">
                  <q-tr :props="props">
                    <template v-if="props.cols?.length">
                      <q-th
                          :key="props.cols[0]?.name"
                          :props="props">
                        {{ props.cols[0]?.label }}
                      </q-th>
                      <q-th
                          :key="props.cols[1]?.name"
                          :props="props">
                        {{ props.cols[1]?.label }}
                      </q-th>
                      <q-th
                          v-for="col in props.cols.slice(2, props.cols.length)"
                          :key="col.name"
                          :props="props">
                    <span style="display: grid">
                      <small>{{ col.label }}<span
                          v-if="
                          unrouted_wr_trips[col.label].strip_tripType === 'DEP'
                        "
                          class="color_red">
                        <i class="material-icons">flight_takeoff</i>
                      </span>
                         <span
                             v-else-if="unrouted_wr_trips[col.label].strip_tripType === 'EXCRS'"
                             class="color_blue">
                        <i class="material-icons">kayaking</i>
                      </span>
                      <span
                          v-else
                          class="color_blue">
                        <i class="material-icons">flight_land</i>
                      </span></small>
                      <span>{{
                          unrouted_wr_trips[col.label] ? formatUnxTime(
                              unrouted_wr_trips[col.label].strip_time,
                              true
                          ) : ''
                        }}</span>

                    </span>
                      </q-th>
                    </template>
                  </q-tr>
                </template>
                <template v-slot:top-row="props">
                  <q-tr :props="props">
                    <q-td/>
                    <q-td class="no_padding">
                      <q-badge
                          :class="[
                        {
                          highlight:
                            allUnroutedSelected == true && total_pax > 0,
                          flight_cell: total_pax > 0,
                          empty_cell: total_pax == 0,
                        },
                      ]"
                          @click.native="checked_all()">
                        {{ total_pax }}
                      </q-badge>
                    </q-td>
                    <q-td
                        v-for="col in props.cols.slice(2, props.cols.length)"
                        :key="col.name"
                        class="no_padding">
                      <q-badge
                          v-if="col.name&&unrouted_wr_trips[col.name]"
                          :class="[
                        {
                          highlight:
                            unrouted_wr_trips[col.name].selected_group == true &&
                            unrouted_wr_trips[col.name].pax > 0,
                          flight_cell: unrouted_wr_trips[col.name].pax > 0,
                          empty_cell: unrouted_wr_trips[col.name].pax == 0,
                        },
                      ]"
                          :label="unrouted_wr_trips[col.name].pax"
                          @click.native="checked_col(col.name)"/>
                    </q-td>
                  </q-tr>
                </template>
                <template v-slot:body="props">
                  <q-tr :props="props">
                    <template v-if="props.cols?.length">
                      <q-td
                          style="cursor: pointer"
                          @click="props.expand = !props.expand">
                        <q-badge
                            class="resort_cell"
                            :label="full_loc(props.cols[0].value)"/>
                        <q-btn
                            size="sm"
                            round
                            tabindex="-1"
                            dense
                            :icon="props.expand ? 'remove' : 'add'"
                            style="
                        background: rgb(0, 150, 136);
                        color: #fff;
                        float: right;
                      "/>
                      </q-td>
                      <q-td class="no_padding">
                        <q-badge
                            :class="[
                        'flight_cell',
                        { highlight: props.row.selected_group == true },
                      ]"
                            :label="paxIt(props)"
                            @click.native="checked_row(props.row)"/>
                      </q-td>
                      <q-td
                          v-for="col in props.cols.slice(2, props.cols.length)"
                          :key="col.name"
                          :props="props"
                          class="no_padding"

                          :class="classer(props,col)">
                        <q-badge
                            :class="[
                        {
                          highlight:
                            props.row.selected[col.name] == true &&
                            col.value > 0,
                          flight_cell: col.value > 0,
                          empty_cell: col.value == 0,
                        },
                      ]"
                            :label="paxIt(props,col)"
                            @click.native="checked_cell(props.row, col.name)"/>
                      </q-td>
                    </template>
                  </q-tr>
                  <q-tr
                      v-show="props.expand"
                      :props="props">
                    <q-td
                        colspan="100%"
                        class="no_padding">
                      <q-table
                          :loading="loading"
                          row-key="id"
                          :data="props.row.children"
                          :columns="columns"
                          color="primary"
                          separator="cell"

                          style="border-top: solid 0.4px"
                          :pagination.sync="pagination"
                          hide-bottom
                          hide-header>
                        <template v-slot:body="props">
                          <q-tr
                              :props="props"
                              style="background: rgb(0 154 140)">
                            <template v-if="props.cols?.length">
                              <q-td style="min-width: 200px">
                                <q-badge
                                    class="resort_cell"
                                    :label="props.cols[0].value"/>
                              </q-td>
                              <q-td
                                  class="no_padding"
                                  style="min-width: 44px">
                                <q-badge
                                    :class="[
                                'flight_cell',
                                { highlight: props.row.selected_group == true },
                              ]"
                                    :label="paxIt(props)"
                                    @click.native="checked_row(props.row)"/>
                              </q-td>
                              <q-td
                                  v-for="col in props.cols.slice(
                              2,
                              props.cols.length
                            )"
                                  :key="col.name"
                                  :props="props"
                                  class="no_padding"

                                  :class="classer(props,col)"
                                  style="min-width: 76px">
                                <q-btn-dropdown
                                    v-if="col.value"
                                    split
                                    rounded
                                    :persistent="true"

                                    :class="[
                                {
                                  highlight:
                                    props.row.selected[col.name] == true &&
                                    col.value > 0,
                                  flight_cell: col.value > 0,
                                  empty_cell: col.value == 0,
                                },
                              ]"
                                    :label="paxIt(props,col)"
                                    @click="checked_cell(props.row, col.name)">
                                  <q-list>
                                    <q-item
                                        v-for="bk in findAllInArray(props.row.bookings, {for_trip: col.name})"
                                        :key="bk.bk_id"
                                        clickable
                                        :class="classer(bk)"

                                        @click="checked_cell(props.row, col.name,null,bk)">
                                      <p>
                                        <q-icon
                                            name="star"
                                            :color="bk._selected?'orange':'grey'"/>
                                        {{ bk.pax }}
                                        <q-badge
                                            v-if="bk.meantype && bk.meantype != 'normal'"
                                            type="warning">{{ bk.meantype }}
                                        </q-badge>


                                        <small>{{
                                            bk.toc_coname
                                          }},{{ bk.customer }}({{ bk.starting_time }})
                                        </small>
                                      </p>
                                    </q-item>
                                  </q-list>

                                </q-btn-dropdown>
                              </q-td>
                            </template>
                          </q-tr>
                        </template>
                      </q-table>
                    </q-td>
                  </q-tr>
                </template>
              </q-table>
            </div>
          </div>

          <div
              v-fill-height="{container:'row',topOffset:'120px',noStyles:true}"
              class="routed_bookings_container"

              style="overflow:auto;"
              v-if="data != null&&data.length"
              :class="[{ full_width: unrouted_data == null }]">
            <div class="bookings_tree_container">
              <div
                  class="left-timeline-gap"></div>
              <div
                  class="bookings_tree shrink"
                  style="flex-grow: 1">

                <el-tree
                    class="filter-tree"
                    :data="filteredRoutes"
                    :key="clock"
                    :default-expanded-keys="expandNodes"
                    node-key="id"
                    :expand-on-click-node="false"
                    @node-click="handleNodeClick"
                    @node-drop="handleDrop"
                    @node-drag-end="reOrderTimes"
                    draggable
                    @node-expand="handleExpantion($event,true)"
                    @node-collapse="handleExpantion($event,false)"
                    :allow-drop="allowDrop"
                    :allow-drag="allowDrag"

                    vsloading="loading"
                    ref="tree"
                    show-checkbox
                    @check-change="handleCheckChange">
                  <div
                      class="treeNode"
                      slot-scope="{ node, data }">
                    <div :class="classer(data)" :title="titler(data)">
                      <!--                    <span >-=-=-{{ data.route_published_at }}</span >-->
                      <template v-if="node.isLeaf == true">
                        <div :class="'treeNode_header '+ themeCtx">

                          <div
                              class="treeNode_Label"
                              :title="node.label">
                            <i class="material-icons">supervisor_account</i>{{ data.pax }}<i class="material-icons">schedule</i>{{
                              data._bkDisplayTime
                            }}
                            <q-btn size="sm"


                                   @click="showBookingId=data.bk_id;showBooking=true">
                              {{
                                data.customer
                              }}({{ data._reference }}):{{
                                data.meantype
                              }}


                            </q-btn>
                            <!--                          <el-link-->
                            <!--                              :href="data.bk_link"-->
                            <!--                              target="_blank">-->
                            <!--                            <small>{{-->
                            <!--                                data.customer-->
                            <!--                              }}({{ data._reference }}):{{-->
                            <!--                                data.meantype-->
                            <!--                              }}-->
                            <!--                            </small>-->

                            <!--                          </el-link>-->
                          </div>

                        </div>
                        <div class="treeNode_info">
                          <div
                              v-for="(
                          grouping_choice, index
                        ) in info_grouping_choices"
                              :key="index"
                              class="treeNode_info_ticket">
                            <strong>{{ data[grouping_choice] }}</strong>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <el-row
                            v-if="node.level == 1"
                            style="padding-bottom: 3px"
                            xtype="flex"
                            justify="space-between"
                            :class="'treeNode_header '+themeCtx"
                            :title="node.data.routeNum">


                          <el-col :class="{'left-timeline':true,'floating-timeline':node.expanded}">

                            <q-btn
                                :title="lastRouteUpdated==data.routeNum?'This is a new route':''"
                                :color="lastRouteUpdated==data.routeNum?'accent':'secondary'"
                                tabindex="-1"
                                style="float: left;padding: 1px;"
                                :disabled="!selected_pax&&!checkedNodes"
                                @click="pasteNodes($event, node)"> {{ data.routeNum }} <i class="material-icons">supervisor_account</i>
                              {{ data.pax }}
                            </q-btn>


                            <!--                          </div>-->
                            <!--                          <div>-->
                            <TripExpander
                                @routeAction="resortAction"
                                :choice_labels='{for_trip: "Flight"}'
                                :groupData="data"
                                :node="node"
                                :flights="wr_trips"
                                :locs="locs"
                                stay
                                @expand-group="updateGroups(node,$event)"/>
                            <!--                          </div>-->

                          </el-col>

                          <el-col :class="{'right-timeline':!node.expanded}">

                            <auto-timepicker
                                tabindex="1"
                                no-update
                                :value="node.data.starting_time"
                                @change="routeUpdate(node,$event,node.data.starting_time)"
                                :title="node.label"
                                style="width: 80px;margin-left:13px;float: left"></auto-timepicker>

                            <div style="width: 335px;float: right;padding: 2px">

                              <q-input

                                  dense
                                  :dark="isDark"
                                  tabindex="-1"
                                  title="Bus Sign"
                                  placeholder="B.S."
                                  v-model="node.data.bussign"
                                  @input="routeDriveUpdate(node,'bussign')"
                                  style="width: 80px;margin-left:3px;float: right"></q-input>
                              <vehicle-picker

                                  :key="node.data.routeNum"
                                  :vehicleId.sync="node.data.route_asset_id"
                                  :contactId.sync="node.data.route_driver_contact_id"
                                  @change="routeDriveUpdate(node)"
                                  style="width: 180px"></vehicle-picker>
                            </div>
                            <TripExpander
                                :choice_labels='{routeNum: "Route",loc_code: "Location",pp_name: "Pick-up-Point"}'
                                :groupData="data"
                                :node="node"
                                :flights="wr_trips"
                                :locs="locs"
                                @expand-group="updateGroups(node,$event)"/>

                          </el-col>
                          <!--                        <el-col>-->
                          <!--                          <sf-button type="success" v-if="data.route_published_at"-->
                          <!--                                     confirm="This action will hide this route from the driver`s list,  Are you sure?"-->
                          <!--                                     material="campaign"-->
                          <!--                                     @click="reportRoutes(data)"-->
                          <!--                          ></sf-button>-->
                          <!--                        -->
                          <!--                          <el-button-->
                          <!--                              v-else-->
                          <!--                              type="text"-->

                          <!--                              style="'float:left;color:red"-->
                          <!--                              title="Report to Drivers"-->
                          <!--                              @click="reportRoutes(data)"><span class="material-icons">campaign</span></el-button>-->
                          <!--                        </el-col>-->

                        </el-row>
                        <el-row
                            v-else
                            type="flex"
                            xjustify="start"
                            :class="'treeNode_header '+themeCtx">
                          <el-col
                              style="flex:0"
                              v-if="validTimePicker(node)">
                            <auto-timepicker


                                :value="node.data.starting_time"
                                @change="routeUpdate(node,$event,node.data.starting_time)"
                                :title="node.label"
                                style="width: 60px"></auto-timepicker>
                          </el-col>


                          <el-col
                              style="flex:0"
                              class="treeNode_Label"
                              v-if="data.group_by_parent === 'loc_code'"
                              :title="locs[data.label]?locs[data.label].name:'???'">
                            <strong> {{ data.label }}</strong>
                            <!--                          <template v-if="isMobileDevice()" >-->
                            <!--                            <el-button-->
                            <!--                                @click="reOrderNode(node)"-->
                            <!--                                type="text"-->
                            <!--                                icon="el-icon-top" ></el-button >-->
                            <!--                            <el-button-->
                            <!--                                @click="reOrderNode(node,true)"-->
                            <!--                                type="text"-->
                            <!--                                icon="el-icon-bottom" ></el-button >-->
                            <!--                          </template >-->
                          </el-col>
                          <el-col
                              style="flex:0"
                              class="treeNode_Label"
                              v-else-if="data.group_by_parent === 'for_trip'"

                          >
                            <small> {{ data.label }}&nbsp;</small>
                            {{
                              wr_trips[data.label] ? formatUnxTime(wr_trips[data.label].strip_time, true) : '???'
                            }}
                          </el-col>
                          <el-col
                              style="flex:0"
                              v-else
                              class="treeNode_Label">
                            {{ data.label }}
                            <!--                          <template v-if="isMobileDevice()" >-->
                            <!--                            <el-button-->
                            <!--                                @click="reOrderNode(node)"-->
                            <!--                                type="text"-->
                            <!--                                icon="el-icon-top" ></el-button >-->
                            <!--                            <el-button-->
                            <!--                                @click="reOrderNode(node,true)"-->
                            <!--                                type="text"-->
                            <!--                                icon="el-icon-bottom" ></el-button >-->
                            <!--                          </template >-->
                            <!--                          ::{{ data.routeSeq }}-->
                          </el-col>


                          <el-col style="flex:0 0 1;">
                            <TripExpander
                                :choice_labels="choice_labels"
                                :node="node"
                                :groupData="data"
                                :flights="wr_trips"
                                :locs="locs"
                                @expand-group="updateGroups(node,$event)"/>
                            <div
                                style="float:right;"
                                v-if="isMobileDevice()&&(data.group_by_parent=='loc_code'||data.group_by_parent=='pp_name')">
                              <el-button
                                  @click="reOrderNode(node,true)"
                                  plain
                                  style="float: right;padding: 10px"

                                  size="default"
                                  icon="el-icon-bottom"></el-button>
                              <el-button
                                  @click="reOrderNode(node)"
                                  plain

                                  style="float: right;margin-right: 5px;padding: 10px"
                                  size="default"
                                  icon="el-icon-top"></el-button>

                            </div>
                          </el-col>

                        </el-row>
                      </template>
                    </div>
                  </div>
                </el-tree>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue';
import * as api from "~/api/resource";
import {mapGetters, mapActions} from "vuex";
import axiosLocal from "axios";
import {dragscroll} from "vue-dragscroll";

import STimePicker from "../../Form/STimePicker";
import VehiclePicker from "../../Form/VehiclePicker";
import SimpleTimepicker from "../../Form/SimpleTimepicker";
import TripExpander from "./TripExpander";
//@click="requestDownload('route/getlist',{workingDate:plandate,coids:selectedRoutes,download:1,sort:'startTimeMM',dir:'ASC',limit:0});" >
let locationsTimeTable = {}
let bkOrders = [], predictedSeqs = {}
let last_selected_trips = false, last_selected_date = false, last_selected_booking_filter = false//route:loc,pp


function intToTime(val) {
  if (isNaN(val)) return val
  if (!val || isNaN(val)) return "";
  val = Math.floor(val)
  const h = Math.floor(val / 60),
      m = val % 60;
  return (h < 10 ? "0" + h : h) + ":" + (m < 10 ? "0" + m : m);
}

function getObjectSearchStmp(node) {
  const tripType = node.data.children?.[0].children?.[0]?.children?.[0]?.tripType || node.data.children?.[0]?.children?.[0]?.tripType || node.data.children?.[0]?.tripType,
      routeNum = node.data.routeNum
  if (node.data.group_by_parent == "loc_code")
    return {
      loc_id: node.data.children?.[0].children?.[0]?.loc_id || node.data.children?.[0]?.loc_id, routeNum: routeNum,
      tripType: tripType
    }
  if (node.data.group_by_parent == "pp_name")
    return {
      ppid: node.data.children[0].children[0].ppid, routeNum: routeNum,
      tripType: tripType
    }
  if (node.data.group_by_parent == "routeNum")
    return {
      routeNum: routeNum,
      tripType: tripType
    }
  return false
}


function trainBkOrders(bk, pup, loc) {
  if (!bk) {
    bkOrders = []
    return
  }

  let levelDeep = bk.group_by_parent == "pp_name"
  // bk.routeSeq = !bk.routeSeq ? 0 : (levelDeep ? bk.routeSeq : 0)
  const find = bkOrders.filter(el => {
    return el.pup == pup && loc == el.loc
  }), findChecks = find.length != bkOrders.length
  if (!find.length) bkOrders.push({routeSeq: bk.routeSeq, starting_time: bk.starting_time, pup: pup, loc: loc})
  else {
    return
  }
  let timesToSort = [],
      times = JSON.parse(JSON.stringify(bkOrders.sort((a, b) => a.starting_time - b.starting_time)))
  bkOrders = bkOrders.sort((a, b) => a.routeSeq - b.routeSeq)

  // _log_('trainBkOrders...', times, bkOrders)

  let lastStartingTime = 0
  bkOrders.forEach((tm, ii) => {
    let stm = times[ii].starting_time;
    //if (stm < lastStartingTime) stm = lastStartingTime + 1
    timesToSort.push({routeSeq: tm.routeSeq, pup: tm.pup, loc: tm.loc, starting_time: stm})
    lastStartingTime = stm
  })
  bkOrders = JSON.parse(JSON.stringify(timesToSort));

}

function getBkOrder(bk, deep, getTime) {
  //_log_('ndchildNodes KEY getBkOrder:', bkOrders, bk)
  for (let i = 0; i < bkOrders.length; i++) {
    const bk_o = bkOrders[i]
    if (deep) {
      if (bk_o.pup && ((bk.pp_name && bk_o.pup == bk.pp_name) || (bk.label && bk_o.pup == bk.label))) {
        return getTime ? bk_o.starting_time : bk_o.routeSeq
      }
    } else if (!bk_o.pup && ((bk_o.loc == bk.loc_code) || (bk.label && bk_o.loc == bk.label))) {
      return getTime ? bk_o.starting_time : bk_o.routeSeq
    }
  }
  return false
}

function getTimeRanges(objects) {
  // Initialize a map to store the groups by id
  const groups = new Map();

  // Iterate through the array of objects
  for (const obj of objects) {
    const {loc_code, starting_time} = obj;

    // If the id is not in the map, add it with the initial time values
    if (!groups.has(loc_code)) {
      groups.set(loc_code, {loc_code, minTime: starting_time, maxTime: starting_time, bks: [obj]});
    } else {
      // Update the minTime and maxTime if necessary
      const group = groups.get(loc_code);
      group.bks.push(obj)
      if (starting_time < group.minTime) {
        group.minTime = starting_time;
      }
      if (starting_time > group.maxTime) {
        group.maxTime = starting_time;
      }
    }
  }

  // Convert the map values to an array
  return Array.from(groups.values());
}

function findOverlappingRanges(ranges) {
  const overlappingRanges = [];

  for (let i = 0; i < ranges.length; i++) {
    for (let j = i + 1; j < ranges.length; j++) {
      const rangeA = ranges[i];
      const rangeB = ranges[j];
      if (rangeA.maxTime >= rangeB.minTime && rangeA.minTime <= rangeB.maxTime) {
        _log_('rangeA rangeB', rangeA, rangeB)
        // Add the ranges[i] if it's not already in the list
        if (!overlappingRanges.includes(rangeA)) {
          rangeA.conflictLoc = rangeB.loc_code
          rangeA.bks = rangeA.bks.filter(bk => rangeB.maxTime > bk.starting_time && rangeB.minTime < bk.starting_time)
          overlappingRanges.push(rangeA);
        }
        // Add the ranges[j] if it's not already in the list
        if (!overlappingRanges.includes(rangeB)) {
          rangeB.conflictLoc = rangeA.loc_code
          rangeB.bks = rangeB.bks.filter(bk => rangeA.maxTime > bk.starting_time && rangeA.minTime < bk.starting_time)
          overlappingRanges.push(rangeB);
        }
      }
    }
  }

  return overlappingRanges;
}

function getwr_trips(list) {
  var wr_trips = {};
  for (let i = 0; i < list.length; i++) {
    // wr_trips[list[i]["for_trip"]] = {
    //   label: list[i]["for_trip"],
    //   pax: list[i]["pax"],
    //   selected_group: false,
    //   strip_time: list[i]["strip_time"],
    //   strip_dir: list[i]["strip_dir"],
    // };
    if (wr_trips[list[i]["for_trip"]] == null) {
      wr_trips[list[i]["for_trip"]] = {
        label: list[i]["for_trip"],
        pax: list[i]["pax"],
        selected_group: false,
        strip_time: list[i]["strip_time"],
        strip_dir: list[i]["strip_dir"],
        strip_tripType: list[i]["strip_tripType"],
      };
    } else {
      wr_trips[list[i]["for_trip"]].pax += list[i]["pax"];
    }
  }

  return wr_trips;
}

function getLocations(list) {
  var locs = {};
  for (let i = 0; i < list.length; i++) {
    if (locs[list[i]["loc_code"]] == null) {
      locs[list[i]["loc_code"]] = {
        name: list[i]["loc_name"],
        code: list[i]["loc_code"],
      };
    }
  }
  return locs;
}

function table_dataset_conversion(list, wr_trips) {
  var flags = [],
      children_flags = [],
      dataset = [],
      i,
      j,
      k,
      loc_counter = 0,
      child_counter = [],
      id_counter = 0;
  for (i = 0; i < list.length; i++) {
    list[i]["id"] = i;
    if (flags[list[i]["loc_code"]]) {
      for (j = 0; j < loc_counter; j++) {
        if (dataset[j]["label"] === list[i]["loc_code"]) {
          dataset[j][list[i]["for_trip"]] += list[i]["pax"];
          dataset[j]["bookings"].push(list[i]);
          dataset[j]["pax"] += list[i]["pax"];
          if (children_flags[j][list[i]["pp_name"]]) {
            for (k = 0; k < child_counter[j]; k++) {
              if (dataset[j]["children"][k]["label"] === list[i]["pp_name"]) {
                dataset[j]["children"][k][list[i]["for_trip"]] +=
                    list[i]["pax"];
                dataset[j]["children"][k]["bookings"].push(list[i]);
                dataset[j]["children"][k]["pax"] += list[i]["pax"];
              }
            }
          } else {
            dataset[j]["children"].push({
              id: id_counter++,
              label: list[i]["pp_name"],
              pax: list[i]["pax"],
              bookings: [list[i]],
              selected: {},
              selected_group: false,
            });
            for (let flight in wr_trips) {
              dataset[j]["children"][child_counter[j]][flight] = 0;
            }
            dataset[j]["children"][child_counter[j]][list[i]["for_trip"]] =
                list[i]["pax"];
            dataset[j]["children"][child_counter[j]]["parent"] = dataset[j];

            children_flags[j][list[i]["pp_name"]] = true;
            child_counter[j]++;
          }
          break;
        }
      }
    } else {
      dataset.push({
        id: id_counter++,
        label: list[i]["loc_code"],
        pax: list[i]["pax"],
        bookings: [list[i]],
        children: [
          {
            id: id_counter++,
            label: list[i]["pp_name"],
            pax: list[i]["pax"],
            bookings: [list[i]],
            selected: {},
            selected_group: false,
          },
        ],
        selected: {},
        selected_group: false,
      });
      for (let flight in wr_trips) {
        dataset[loc_counter][flight] = 0;
        dataset[loc_counter]["children"][0][flight] = 0;
      }
      dataset[loc_counter][list[i]["for_trip"]] = list[i]["pax"];
      dataset[loc_counter]["children"][0][list[i]["for_trip"]] =
          list[i]["pax"];
      dataset[loc_counter]["children"][0]["parent"] = dataset[loc_counter];

      children_flags[loc_counter] = [];
      children_flags[loc_counter][list[i]["pp_name"]] = true;
      child_counter[loc_counter] = 1;
      loc_counter++;
      flags[list[i]["loc_code"]] = true;
    }
  }
  // this.unrouted_data=   rowDataSorter(  this.unrouted_data)
  //_log_("table_dataset_conversion ", dataset);
  // return rowDataSorter(dataset);
  return dataset
}


// function getBookingList(groupedBookings) {
//   var list = [];
//   if (groupedBookings.parent_labels == []) {
//     list = groupedBookings;
//   } else if (groupedBookings.group_by != null) {
//     list = groupedBookings.children;
//   } else {
//     return [groupedBookings];
//   }
//   if (list == null) {
//     return null;
//   }
//
//   var bookingList = [];
//   for (let i = 0; i < list.length; i++) {
//     Array.prototype.push.apply(bookingList, getBookingList(list[i]));
//   }
//   return bookingList;
// }

function getSelected_UnroutedBookings(groupedBookings, list, allSelected) {
  var selected_bookings = [];
  if (allSelected == true) {
    Array.prototype.push.apply(selected_bookings, list);
  } else {
    let i, j, k;
    for (i = 0; i < groupedBookings.length; i++) {
      if (groupedBookings[i].selected_group == true) {
        Array.prototype.push.apply(
            selected_bookings,
            groupedBookings[i].bookings
        );
      } else {
        if (groupedBookings[i].children != null) {
          for (j = 0; j < groupedBookings[i].children.length; j++) {
            if (groupedBookings[i].children[j].selected_group == true) {
              Array.prototype.push.apply(
                  selected_bookings,
                  groupedBookings[i].children[j].bookings
              );
            } else {
              for (
                  k = 0;
                  k < groupedBookings[i].children[j].bookings.length;
                  k++
              ) {
                if (
                    groupedBookings[i].children[j].selected[
                        groupedBookings[i].children[j].bookings[k].for_trip
                        ] == true
                ) {
                  selected_bookings.push(
                      groupedBookings[i].children[j].bookings[k]
                  );
                }
              }
            }
          }
        }
      }
    }
  }
  // selected_bookings
  return selected_bookings;
}

function newRouteID() {
  return "10";
}

const dflt_grouping_choices = [
  "routeNum",
  "loc_code",
  "pp_name",
  "for_trip",
  "toc_coname",

]
export default {
  components: {TripExpander, VehiclePicker},
  directives: {
    dragscroll: dragscroll,
  },
  data() {
    return {
      showBooking: false,
      showBookingId: null,
      alwaysSyncBookedTimes: false,
      meetingPointPriority: true,
      flushingRoutes: false,
      expandNodes: null,
      undoCount: 0,
      clock: 0,
      vehicles: null,
      form: {
        date: "",
        flight_type: "",
      },
      warnIcons: {
        _time_not_set_: 'departure_board',
        _trip_time_excess_: 'history',
        _not_scheduled_time_: 'manage_history',
        _time_conflicts_: 'running_with_errors',
        _route_check_: 'more_time'
      },
      selected_routed_pax: 0,
      flight_type: "",
      checkedNodes: false,
      checkedRoutes: false,
      total_list: [],
      wr_trips: {},
      locs: {},

      list: [],
      warning_mode: false,
      data: null,
      // grouping_choices: [
      //   "routeNum",
      //   "loc_code",
      //   "pp_name",
      //   "for_trip",
      //   "toc_coname",
      //
      // ],
      info_grouping_choices: [
        "routeNum",

        "loc_code",
        "pp_name",
        "for_trip",
        "toc_coname",

      ],
      choice_labels: {
        routeNum: "Route",
        loc_code: "Location",
        pp_name: "Pick-up-Point",

        for_trip: "Flight",
        toc_coname: "Company",
      },
      group_by: 0,
      autoRouting: false,
      publishState: 0,
      pagination: {
        sortBy: "total",
        descending: true,
        page: 1,
        rowsPerPage: 0,
      },
      unrouted_wr_trips: {},
      unrouted_bookings: [],
      unrouted_data: null,
      columns: [],
      allUnroutedSelected: false,
      // total_pax: 0,
      unrouted_selected_pax: 0,
      lastRouteUpdated: null,
      loading: false,
    };
  },
  async mounted() {
    _log_('$route.id.....mounted..')
    last_selected_booking_filter = null
    last_selected_trips = null
    last_selected_date = null
    const {data} = await api.fetchProcessor("vue_route/autocomposer", {

      do: "isReportOn",

    });
    this.getUndoMovesCount()
    this.publishState = data?.time
    _log_('time....mounted..', data)
    // await this.loadSeqPatterns()
    await this.fetchAllOptions('drivers')

  },
  watch: {
    // loading(v, vo) {
    //   if (v == vo) return
    //   this.$emit('loading', v)
    // },
    '$route.query.search'(v, vo) {
      if (v != vo) {
        this.searchBookings(v)
        // if (found) ++this.clock
        return


      }
    },
    '$route.query.select_routes'(v, vo) {
      if (v != vo) {

        // const checkedNodes = this.$refs.tree.getCheckedNodes();

        if (this.data) this.data.forEach(nd => {

          this.$refs.tree.setChecked(nd.id, this.$route.query.select_routes == 'all', true)
        })

      }
    },
    '$route': {
      handler: _.debounce(async function (to, from) {
        _log_('$route.id.......', last_selected_date, this.$route.params.trips)
        if (!this.wTripTypes && !this.$route.query.booking_filter) return

        //     last_selected_trips, this.$route.params.trips)(this.unrouted_data == null && this.data == null) ||
        if (last_selected_trips === false) last_selected_trips = this.wTripTypes
        if (last_selected_date === false) {
          last_selected_date = this.$route.query.date
          this.resetData()
        }
        if (last_selected_booking_filter === false) last_selected_booking_filter = this.$route.query.booking_filter//(this.unrouted_data == null && this.data == null) ||
        if (this.$route.params.trips && this.$route.query.date && (this.wTripTypes != last_selected_trips || last_selected_booking_filter != this.$route.query.booking_filter || this.$route.query.date != last_selected_date)) {
          const diff_selected_date = last_selected_date != this.$route.query.date,
              diff_selected_trips = last_selected_trips != this.wTripTypes,
              diff_selected_booking_filter = last_selected_booking_filter != this.$route.query.booking_filter

          last_selected_date = this.$route.query.date
          last_selected_trips = this.wTripTypes
          last_selected_booking_filter = this.$route.query.booking_filter
          this.form.flight_type = this.$route.params.trips
          this.form.date = this.$route.query.date
          _log_('$route.id.....diffs.loading from watch.', diff_selected_booking_filter, diff_selected_trips, diff_selected_date)
          await this.loadTheBookings(diff_selected_date, diff_selected_trips, diff_selected_booking_filter)


        }

      }, 700),
      immediate: true
    }

  },
  computed: {
    filteredRoutes() {
      if (!this.warning_mode)
        return this.data
      return this.data.filter(nd => !!nd._hasWarning)
    },
    problems() {
      // _log_('transferData.forEach.problems..', this.data)
      if (!this.data?.length) return null
      let o = {}
      this.data.forEach(rt => {
        // _log_('transferData.forEach...', rt)

        if (rt._hasWarning)
          rt.group.forEach(it => {
            if (!!it._warnings && it._warnings != 'dismiss' && _.isObject(it._warnings)) {

              for (const warningsKey in it._warnings)
                o[warningsKey] = (o[warningsKey] || 0) + 1;
            }
          })
      })
      // _log_('transferData.forEach...',o)
      return Object.keys(o)?.length ? o : null
    },
    excrsMode() {
      return this.$route.params.trips == 'EXCRS'
    },
    wTripTypes() {
      //
      return this.$route.params.trips
    },
    selected_pax() {
      return this.unrouted_selected_pax + this.selected_routed_pax
    },
    isDark() {
      return this.themeCtx == 'dark'
    },
    total_pax() {
      // if (!this.unrouted_bookings) return 0

      // const extras =this.$refs.tree? this.$refs.tree.getCheckedNodes():null
      // _log_('go sort..!this.unrouteBookings(..',  this.selected_routed_pax)
      let pax = this.unrouted_bookings ? this.unrouted_bookings.reduce((partialSum,
                                                                        a) => partialSum + (a.pax ? a.pax * 1 : 0), 0) : 0;
      return pax
    },
    selectedInfo() {
      if (!this.$refs.tree) return null
      const checkedNodes = this.$refs.tree.getCheckedNodes();
      if (checkedNodes)
        return checkedNodes
      return null
    }
  },
  methods: {
    prepareRouteElements(arr, byProp = 'bk_id') {
      if (!arr || !byProp) return

      let unique_index = {}, out = []
      arr.forEach(elm => {
        if (elm.strip_dir == 'ARV')
          elm._order = elm.routeSeq * 100000 + elm.starting_time
        else elm._order = elm.starting_time * 100000 + elm.routeSeq
        if (!elm.id && elm[byProp]) elm.id = elm[byProp]
        if (!elm[byProp])
          out.push(elm)
        else if (!unique_index[elm[byProp]]) {
          out.push(elm)
          unique_index[elm[byProp]] = true
        }
      })
      return out;
    },
    parentUpdate(node, toMax = false) {


      let parentNode = node.parent
      if (!parentNode) return
      let min = null, max = null
      let group = parentNode?.data?.group || parentNode?.data;
      group?.forEach((nd) => {
        // _log_('about to parentUpdate nd ', nd.starting_time, '<', parentNode.data.starting_time)
        min = parseInt(!min || min > nd.starting_time ? nd.starting_time : min)
        max = parseInt(!max || max < nd.starting_time ? nd.starting_time : max)
      })
      group = group.sort((a, b) => a._order - b._order)
      if (group.children && _.isArray(group.children))
        group.children = group.children.sort((a, b) => a._order - b._order)
      _log_('about to parentUpdate ', node, min, max, toMax)
      let timeData = parentNode.data.starting_time !== undefined ? parentNode.data : (parentNode.starting_time != undefined ? parentNode : null)
      if (timeData) {
        this.$set(timeData, 'starting_time', toMax ? max : min);

        this.$set(timeData, 'finalPickupTime', intToTime(timeData.starting_time));
        // if (node?.data?._hasWarning !== undefined && parentNode.data)
        timeData._hasWarning = node.data._hasWarning
      }
      if (parentNode?.data)
        this.parentUpdate(parentNode, toMax)
    },


    deepUpdate(node, updateObject, timeMaps = {locs: {}, pups: {}}) {
      _log_('deepUpdate to updateObject ', node, updateObject)
      let bks = node.data?.children && _.isArray(node.data.children) ? node.data.children : null// || node.children || node
      if (!bks && node.children && _.isArray(node.children))
        bks = node.children
      if (!bks && _.isArray(node)) bks = node
      //update
      const pbk = node.data || node

      let min = null, max = null
      if (bks?.length)
        bks.forEach(bk => {
          bk = bk.data || bk
          min = parseInt(!min || min > bk.starting_time ? bk.starting_time : min)
          max = parseInt(!max || max < bk.starting_time ? bk.starting_time : max)
          //update
          if (bk.children && _.isArray(bk.children))
            this.deepUpdate(bk, updateObject, timeMaps)
          else {
            let ppTime = timeMaps.pups?.[bk.pp_id]
            // let pp_starting_time = ppTime?.pup
            if (!ppTime) {

              if (bk.starting_time !== undefined) {
                ppTime = bk.starting_time - (updateObject?.offset || 0)
                timeMaps.pups[bk.pp_id] = ppTime
                timeMaps.locs[bk.loc_id] = !timeMaps.locs[bk.loc_id] || timeMaps.locs[bk.loc_id] > timeMaps.pups[bk.pp_id] ? timeMaps.pups[bk.pp_id] : timeMaps.locs[bk.loc_id]
                // this.$set(bk, 'starting_time', bk.starting_time - updateObject.offset);
              } else console.error('not sure but this bk has no initial time')
            }
            if (bk.starting_time !== undefined) this.$set(bk, 'starting_time', timeMaps.pups[bk.pp_id]);

            if (bk.finalPickupTime !== undefined) this.$set(bk, 'finalPickupTime', intToTime(timeMaps.pups[bk.pp_id]));

            // if (bk.starting_time !== undefined) this.$set(bk, 'starting_time', bk.starting_time - updateObject.offset);
            //
            // if (bk.finalPickupTime !== undefined) this.$set(bk, 'finalPickupTime', intToTime(bk.starting_time));
            if (bk.tripType != 'EXCRS' || this.alwaysSyncBookedTimes) {
              this.$set(bk, '_bkDisplayTime', bk.finalPickupTime);
              this.$set(bk, 'bookedTimeMM', bk.finalPickupTime)
            }
          }
        })

      bks = bks.sort((a, b) => a._order - b._order)
      _log_('deepUpdate to update ', node)
      if (node.children && _.isArray(node.children))
        node.children = node.children.sort((a, b) => a._order - b._order)
      let timeData = node.data?.starting_time !== undefined ? node.data : (node?.starting_time != undefined ? node : null)
      if (timeData) {
        this.$set(timeData, 'starting_time', this.wTripTypes == 'ARV' ? max : min);

        this.$set(timeData, 'finalPickupTime', intToTime(timeData.starting_time));

      }
      // if (updateObject?.offset) {
      if (pbk.starting_time !== undefined)
        this.$set(pbk, 'starting_time', pbk.starting_time - (updateObject?.offset || 0));

      if (pbk.finalPickupTime !== undefined) this.$set(pbk, 'finalPickupTime', intToTime(pbk.starting_time));
      // bkInfo.tripType == 'EXCRS' ? bkInfo.bookedTimeMM
      if (pbk.tripType != 'EXCRS' || this.alwaysSyncBookedTimes) {//_bkDisplayTime
        this.$set(pbk, '_bkDisplayTime', pbk.finalPickupTime);
        this.$set(pbk, 'bookedTimeMM', pbk.finalPickupTime);
        // if (this.$route.params.trips != 'EXCRS')

      }
      this.parentUpdate(node, pbk.tripType == 'ARV')
      _log_('AFTER to update ', node)
      _log_('AFTER to END ', node)
      // }
      // if (!updateObject)
      //   this.parentUpdate(node, pbk.tripType == 'ARV')
    },

    searchBookings(v) {
      if (!v) {
        this.total_list.forEach(bk => {
          this.$set(bk, '_found', false)
        })
        return
      }
      const s = v.toLowerCase()
      _log_('>>>>> _found', this.unrouted_data)
      let found = false
      // const checkedNodes = this.$refs.tree.getCheckedNodes();
      this.total_list.forEach(bk => {

        if (bk.customer?.toLowerCase().includes(s) || bk.reference?.toLowerCase().includes(s)) {
          _log_('>>>>> _found T')
          // this.$set(nd, '_found', true)
          this.$set(bk, '_found', true)
          found = true
        } else this.$set(bk, '_found', false)
      })
    },
    titler(bkData) {
      return bkData._warnings ? Object.values(bkData._warnings).join(' . ') : null
    },
    classer(bkData, origin) {
      //bk in findAllInArray(props.row.bookings, {for_trip: col.name})
      bkData = bkData?.row || bkData
      // _log_('classer(bkData) ', origin, bkData)
      let classes = ['rt-line']//_hasWarning:bkInfo._hasWarning,
      if (bkData._private) classes.push('private-route')
      if (bkData._hasWarning) classes.push('warnings-route')
      if (origin) {
        const sBks = this.findAllInArray(bkData.bookings, {for_trip: origin.name})
        if (sBks) {
          for (let i = 0; i < sBks.length; i++) {
            const sBk = sBks[i];
            if (sBk?._found) {
              classes.push('fount-route')
              break
            }
          }
        }
        // _log_('classer(bkData) ??', classes)
        // nd.children.forEach(bk => {
        //
        //   if (bk.customer?.toLowerCase().includes(s) || bk.reference?.toLowerCase().includes(s)) {
        //
        //   } else this.$set(bk, '_found', false)
        // })
      } else {

        if (bkData._found) classes.push('fount-route')
        else {
          // const sBks = bkData.bookings?.length ? bkData.bookings : (bkData.children && isNaN(bkData.children) && bkData.children?.length ? bkData.children : null)
          const sBks = bkData.bookings?.length ? bkData.bookings : bkData.group
          // _log_('classer(sBks) ', sBks)
          if (sBks)
            for (let i = 0; i < sBks.length; i++) {
              const sBk = sBks[i];
              if (sBk?._found) {
                classes.push('fount-route')
                break
              } else {
                const ssBks = sBk.bookings?.length ? sBk.bookings : (sBk.children && isNaN(sBk.children) && sBk.children?.length ? sBk.children : null)
                // _log_('classer(sBks) ', ssBks)
                if (ssBks)
                  for (let i = 0; i < ssBks.length; i++) {
                    const ssBk = ssBks[i];
                    if (ssBk?._found) {
                      classes.push('fount-route')
                      break
                    }
                  }
              }
            }
        }
      }
      return classes.join(' ')
    },
    async togglePauseRouteReport() {

      const {data} = await api.fetchProcessor("vue_route/autocomposer", {

        do: "togglePauseRouteReport",

      });
      this.publishState = data?.time
    },
    async reportRoutes(routeO, publish_time = null) {//not used for now
      let selected = null
      if (routeO) {
        selected = [routeO.routeNum]
        publish_time = routeO.route_published_at ? 0 : (new Date());
        routeO.route_published_at = publish_time ? publish_time.getTime() / 1000 : publish_time
        _log_('routeO', routeO)
      } else {
        publish_time = publish_time !== null ? publish_time : (new Date())
        let checkedNodes = this.$refs.tree.getCheckedNodes();
        if (checkedNodes?.length) {
          let uniq = {}
          checkedNodes.forEach(r => r.route_published_at = publish_time)
          selected = checkedNodes.map(r => r.routeNum).filter(r => {
            if (!uniq[r]) {
              uniq[r] = true
              return true
            }
            return false
          })
        }


        // this.loadedRoutes = data.results
      }
      const {data} = await api.fetchProcessor('vue_route/transfers/getlist', {

        selectedRoutes: selected,
        _update: JSON.stringify({published_at: publish_time})
      })
    }
    ,
    async resortAction({action, node}) {
      this.loading = true
      _log_('eventAct,node', action, node)
      if (action == 'force-booked-time' && node.data.group?.length) {
        node.data.group.forEach(bk => {
          // if(  bk.finalPickupTime != bk.bookedTimeMM)
          _log_('eventAct,node???', bk.starting_time, bk.finalPickupTime, bk.bookedTimeMM, bk)
          bk.finalPickupTime = bk.bookedTimeMM
          if (bk.finalPickupTime) bk.starting_time = this.strTimeToInt(bk.finalPickupTime)
        })

      }
      this.prepareRouteElements(node.data.group)
      this.deepUpdate(node)
      this.updateGroups(node)
      const inititalTime = node.data.starting_time * 1
      await this.routeUpdate(node)
      // await this.routeUpdate(node, inititalTime + 1, inititalTime)
      // await this.routeUpdate(node, inititalTime, inititalTime + 1)
      ++this.clock
      this.loading = false
    }
    ,
    renderBooking(bkInfo) {


      bkInfo._hasWarning = !!bkInfo._warnings
      if (bkInfo.meantype) bkInfo._private = bkInfo.meantype.indexOf('priv') >= 0 || bkInfo.meantype.indexOf('taxi') >= 0
      else bkInfo._private = false
      bkInfo.bk_link = bkInfo.bk_link ? bkInfo.bk_link : this.makeBookingLink(bkInfo)
      bkInfo._reference = bkInfo.tripType == 'EXCRS' ? bkInfo.ticketNum : bkInfo.reference
      this.$set(bkInfo, '_bkDisplayTime', bkInfo.tripType == 'EXCRS' ? bkInfo.bookedTimeMM : bkInfo.finalPickupTime)
      if (bkInfo["bk_id"]) bkInfo["label"] = bkInfo["bk_id"].toString();
      return bkInfo
      ///spa/#/tripsmanager/excrs/tripadmin/12159/bookings/booking/378712?bookingid=378712
    }
    ,
    ...
        mapActions({
          fetch: "tags/fetch",
          fetchAllOptions: "tags/fetchAll",
        }),
    async reOrderNode(nd, down) {

      let ndBefore = null, ndAfter = null
      // if (!down)
      if (nd.parent && nd.parent.childNodes)
        if (down) {
          for (const childNodesKey in nd.parent.childNodes) {
            if (nd.id == nd.parent.childNodes[childNodesKey].id)
              ndAfter = 1
            else if (ndAfter === 1) {
              ndAfter = nd.parent.childNodes[childNodesKey]
              break
            }
          }
        } else
          for (const childNodesKey in nd.parent.childNodes) {
            if (nd.id != nd.parent.childNodes[childNodesKey].id)
              ndBefore = nd.parent.childNodes[childNodesKey]
            else break
          }
      _log_('go sort.reOrderNode(ndBefore) .', ndBefore)
      if (ndBefore) {

        this.$refs.tree.remove(nd)
        this.$refs.tree.insertBefore(nd.data, ndBefore)
      } else if (ndAfter && ndAfter !== 1) {
        this.$refs.tree.remove(nd)
        this.$refs.tree.insertAfter(nd.data, ndAfter)
      }
      await this.adjustNewSeq(ndAfter ? ndAfter : ndBefore);
      // this.$refs.tree.remove(nd)

    }
    ,
    rowDataSorter(data, sortBy, descending) {

      return data.sort((a, b) => (a.label > b.label ? 1 : (a.label === b.label ? 0 : -1)))
    }
    ,
    paxIt(books, colInfo) {
      //props.cols[1].value+'!!'
      // _log_('paxxx....', colInfo, books)

      if (!books.row) return 0
      if (!books.row.bookings) return 0
      let out = []
      if (colInfo) {
        const col_flight = colInfo.field,
            res = books.row.bookings.reduce((partialSum,
                                             a) => ({
              n: partialSum.n + (a.meantype.indexOf('priv') < 0 && a.meantype.indexOf('taxi') < 0 ? (a.pax && a.for_trip == col_flight ? a.pax * 1 : 0) : 0),
              p: partialSum.p + (a.meantype.indexOf('priv') >= 0 || a.meantype.indexOf('taxi') >= 0 ? (a.pax && a.for_trip == col_flight ? a.pax * 1 : 0) : 0)
            }), {
              n: 0,
              p: 0
            });

        if (res.n) out.push(res.n)
        if (res.p) out.push('P:' + res.p)
        return out.join(',')
      }
      const res = books.row.bookings.reduce((partialSum,
                                             a) => ({
        n: partialSum.n + (a.meantype.indexOf('priv') < 0 && a.meantype.indexOf('taxi') < 0 ? (a.pax ? a.pax * 1 : 0) : 0),
        p: partialSum.p + (a.meantype.indexOf('priv') >= 0 || a.meantype.indexOf('taxi') >= 0 ? (a.pax ? a.pax * 1 : 0) : 0)
      }), {
        n: 0,
        p: 0
      });

      if (res.n) out.push(res.n)
      if (res.p) out.push('P:' + res.p)
      return out.join(',')
      //return colInfo.value+'#'
      return books.row.bookings.reduce((partialSum, a) => partialSum + (a.pax ? a.pax * 1 : 0), 0);
      // return books.cols[1].value + '!-!'
    }
    // ,
    // getTheRightTime(bk) {
    //   if (!bk) {
    //     locationsTimeTable = {}
    //     return
    //   }
    //   let timeTable = locationsTimeTable[bk.routeNum] ? locationsTimeTable[bk.routeNum] : []
    //   let idcol = bk.loc_code ? bk.loc_code : bk.label;
    //   if (!idcol) {
    //     console.error('what the hell', bk)
    //     return bk
    //   }
    //   let locTimeIdx = this.findInArray(timeTable, {loc: idcol}, true), locItem = null
    //   if (locTimeIdx !== false) locItem = timeTable[locTimeIdx]
    //   if (locItem) {
    //     let before = timeTable[locTimeIdx - 1], after = timeTable[locTimeIdx + 1]
    //     if (before && bk.starting_time < before.starting_time) {
    //       bk.starting_time = locItem.starting_time
    //       bk.routeSeq = locItem.routeSeq
    //       return bk
    //     }
    //     if (after && bk.starting_time > after.starting_time) {
    //       bk.starting_time = locItem.starting_time
    //       bk.routeSeq = locItem.routeSeq
    //       return bk
    //     }
    //   } else {
    //     timeTable.push({loc: idcol, starting_time: bk.starting_time, routeSeq: (timeTable.length + 1) * 1000})
    //     locationsTimeTable[bk.routeNum] = timeTable
    //   }
    //   if (!bk.routeSeq) bk.routeSeq = timeTable.length * 1000
    //   return bk
    // }
    ,
    groupsSorted(data) {
      const sdata = JSON.parse(JSON.stringify(data));
      //_log_("groupsSorted....", data);
      return sdata.sort((a, b) =>
          b.starting_time ? a.starting_time - b.starting_time : b.pax - b.pax
      );
    }
    ,
    aggr(grouping_choices, index, list, parent_labels) {
      let flags = [],
          aggr_list = [],
          i,
          bkGroup_idx,
          group_options_idx,
          h;
      let key = grouping_choices[index];
      let group_options = grouping_choices.slice();
      // _log_('grouping_choices, index, list, group_options', this.data, group_options)
      group_options.splice(index, 1);
      if (parent_labels == null) parent_labels = [];
      if (!list) return
      list = this.prepareRouteElements(list, 'bk_id')
      // _log_('grouping_choices, index, list, parent_labels', grouping_choices, index, list, parent_labels)
      let last_seq = -1;//list[0] && list[0]['routeSeq'] ? list[0]['routeSeq'] : -1
      let node_key;
      for (i = 0; i < list.length; i++) {
        let bkInfo = list[i];
        bkInfo = this.renderBooking(bkInfo)
        // _log_("bkInfo aggr_list...", bkInfo);
        bkInfo["parent_labels"] = parent_labels;
        const RT_label = bkInfo[key] ? bkInfo[key].toString() : '???';
        if (flags[bkInfo[key]]) {
          node_key = RT_label;
          for (bkGroup_idx = 0; bkGroup_idx < aggr_list.length; bkGroup_idx++) {
            let bkGroup = aggr_list[bkGroup_idx];
            if (bkGroup["label"] === node_key) {
              //handling the children of a higher level
              bkGroup.pax += bkInfo["pax"];
              if (!bkGroup._hasWarning) bkGroup._hasWarning = bkInfo._hasWarning
              if (!bkGroup._private) bkGroup._private = bkInfo._private
              bkGroup.group.push(bkInfo);
              // _log_('grouping_choices routeSeq', bkGroup["starting_time"], bkInfo["starting_time"], bkInfo)
              // bkGroup["routeSeq"] = bkInfo["routeSeq"];
              // bkGroup["starting_time"] = bkInfo["starting_time"];
              if (
                  bkGroup.strip_dir == "ARV" &&
                  bkGroup["starting_time"] < bkInfo["starting_time"]
              ) {
                bkGroup["starting_time"] = bkInfo["starting_time"];
              } else if (
                  bkGroup.strip_dir != "DEP" &&
                  bkGroup["starting_time"] > bkInfo["starting_time"]
              ) {
                bkGroup["starting_time"] = bkInfo["starting_time"];
              }
              for (group_options_idx = 0; group_options_idx < group_options.length; group_options_idx++) {
                const groupOption = group_options[group_options_idx];
                const group_option_items = bkGroup.groupings[groupOption];
                for (
                    h = 0;
                    h < group_option_items.length;
                    h++
                ) {
                  if (
                      group_option_items[h].label ===
                      bkInfo[groupOption]
                  ) {
                    group_option_items[h].pax +=
                        bkInfo["pax"];
                    break;
                  }
                }
                if (h == group_option_items.length) {
                  // _log_('grouping_choices routeSeq..2..', bkInfo[group_options[ group_options_idx]], bkInfo.routeSeq, bkInfo)
                  group_option_items.push({
                    label: bkInfo[groupOption],
                    pax: bkInfo["pax"],
                    routeSeq: bkInfo.routeSeq,
                    _hasWarning: bkInfo._hasWarning,
                    _private: bkInfo._private,//bkInfo.meantype.indexOf('priv') >= 0,
                    starting_time: bkInfo["starting_time"],
                  });
                }
                bkGroup.groupings[groupOption] = group_option_items.sort((a, b) => a._order - b._order);
              }
              break;
            }
          }
        } else {
          // _log_('list[i][key]', key, list[i], list[i][key])
          let tree_id = 'rn_' + bkInfo["routeNum"];
          if (key == 'loc_code') tree_id += '.loc_' + bkInfo["loc_id"] + '.' + bkInfo["bk_id"];
          else if (key == 'routeNum') tree_id = tree_id;
          else if (key == 'pp_name') tree_id += '.pp_' + bkInfo["pp_id"] + '.' + bkInfo["bk_id"];
          else tree_id += '.' + bkInfo[key] + '.' + bkInfo["bk_id"];
          // _log_('route_asset_id grouping_choices routeSeq..3..', RT_label, bkInfo.routeSeq, bkInfo)
          aggr_list.push({
            route_asset_id: bkInfo['route_asset_id'],
            route_driver_contact_id: bkInfo['route_driver_contact_id'],
            label: RT_label,
            pax: bkInfo["pax"],
            _hasWarning: bkInfo._hasWarning,
            _private: bkInfo._private,//.meantype.indexOf('priv') >= 0,
            starting_time: bkInfo["starting_time"],
            group: [bkInfo],
            bussign: bkInfo["bussign"],
            group_by: 0,
            _order: bkInfo._order,
            route_published_at: bkInfo.route_published_at,
            routeSeq: bkInfo["routeSeq"], //>= last_seq ? bkInfo["routeSeq"] : last_seq,
            strip_dir: bkInfo["strip_dir"],
            routeNum: bkInfo["routeNum"],
            id: tree_id,
            group_by_name: group_options[0],
            group_by_parent: key,
            parent_labels: parent_labels,
            grouping_choices: group_options,
            groupings: {},
          });
          for (bkGroup_idx = 0; bkGroup_idx < group_options.length; bkGroup_idx++) {
            // _log_('grouping_choices routeSeq.group_options[bkGroup_idx].3..', group_options[bkGroup_idx], aggr_list[aggr_list.length - 1].groupings, aggr_list[aggr_list.length - 1].groupings[group_options[bkGroup_idx]])
            aggr_list[aggr_list.length - 1].groupings[group_options[bkGroup_idx]] = [
              {
                _hasWarning: bkInfo._hasWarning,
                _private: bkInfo._private,
                label: bkInfo[group_options[bkGroup_idx]],
                pax: bkInfo["pax"],
                _order: bkInfo._order,
                routeSeq: bkInfo.routeSeq,
                starting_time: bkInfo["starting_time"],
              },
            ];
          }

          flags[bkInfo[key]] = true;
        }
        last_seq = bkInfo["routeSeq"]
      }
      if (group_options.length > 0) {
        for (i = 0; i < aggr_list.length; i++) {
          // if (aggr_list[i].routeNum == '70241') {
          //   //_log_('ggr_list[i]', aggr_list[i])
          // }
          // aggr_list[i]["starting_time"] = aggr_list[i]["starting_time"];
          // aggr_list[i] = aggr_list[i].sort((a, b) => (a["starting_time"] - b["starting_time"]) * 100 +
          //     b["pax"] -
          //     a["pax"]
          // )
          for (bkGroup_idx = 0; bkGroup_idx < group_options.length; bkGroup_idx++) {
            if (aggr_list[i].groupings[group_options[bkGroup_idx]].length > 1) {
              break;
            }
          }
          if (bkGroup_idx < group_options.length) {
            let child_labels = parent_labels.slice();
            child_labels.push(aggr_list[i]["label"]);
            aggr_list[i]["children"] = this.aggr(
                group_options,
                bkGroup_idx,
                aggr_list[i]["group"],
                child_labels
            );
            if (
                aggr_list[i]["group_by_name"] === "loc_code" ||
                aggr_list[i]["group_by_name"] === "pp_name" ||
                aggr_list[i]["group_by_name"] === "routeNum"
            ) {
              aggr_list[i].children.sort((a, b) => {
                if (!aggr_list[i]._private) aggr_list[i]._private = a._private || b._private
                return a._order - b._order
                // return (
                //
                //     (a["starting_time"] - b["starting_time"])
                // );
              });
            } else {
              aggr_list[i].children.sort((a, b) => {
                if (!aggr_list[i]._private) aggr_list[i]._private = a._private || b._private
                return b.pax - a.pax;
              });
            }
          } else {
            aggr_list[i]["children"] = aggr_list[i]["group"];
            aggr_list[i].children.sort((a, b) => {
              if (!aggr_list[i]._private) aggr_list[i]._private = a._private || b._private
              return b._order - a._order;
            });
          }
        }
      } else {
        for (i = 0; i < aggr_list.length; i++) {
          // aggr_list[i]["starting_time"] = aggr_list[i]["starting_time"];
          // aggr_list[i]["routeSeq"] = aggr_list[i]["routeSeq"];
          aggr_list[i]["children"] = aggr_list[i]["group"];
          aggr_list[i].children.sort((a, b) => {
            if (!aggr_list[i]._private) aggr_list[i]._private = a._private || b._private
            return b._order - a._order;
          });
        }
      }

      // _log_("result aggr_list...", aggr_list);
      return aggr_list

    }
    ,
    handleCheckChange() {
      if (!this.$refs.tree) return
      const checkedNodes = this.$refs.tree.getCheckedNodes();
      _log_("result aggr_" +
          "list...", checkedNodes);
      if (
          (this.data == null || checkedNodes.length == 0) &&
          (this.unrouted_data == null ||
              getSelected_UnroutedBookings(
                  this.unrouted_data,
                  this.unrouted_bookings,
                  this.allUnroutedSelected
              ).length == 0)
      ) {
        this.checkedNodes = false;
        this.checkedRoutes = false;
      } else if (
          this.data == null ||
          checkedNodes.length == 0
      ) {
        this.checkedNodes = true;
        this.checkedRoutes = false;
      } else {
        this.checkedNodes = true;
        this.checkedRoutes = true;
      }
      //  let pax_selected = 0
      if (checkedNodes) {
        this.selected_routed_pax = checkedNodes.reduce((partialSum,
                                                        a) => partialSum + (a.pax && !_.isArray(a.children) ? a.pax * 1 : 0), 0)
        let gocheckeRoutes = []
        checkedNodes.forEach(rt => {
          // _log_("result aggr_checked rt ", gocheckeRoutes.indexOf(rt.routeNum), rt);
          if (gocheckeRoutes.indexOf(rt.routeNum) < 0) gocheckeRoutes.push(rt.routeNum)
        })
        // _log_("result aggr_checked ", gocheckeRoutes);
        this.routeGo({
          query: {
            checkedRoutes: gocheckeRoutes
                .join(',')
          }
        }, true)
      } else {

      }
    }
    ,
    handleNodeClick(data) {
      // ... Show Booking Data
      //_log_(data);
    }
    ,
    updateGroups(node, grouping_choice = 'loc_code') {
      let index;
      _log_("updateGroups", node, grouping_choice);
      const sortProp = this.wTripTypes == 'ARV' ? "routeSeq" : "starting_time";
      if (node.group) this.prepareRouteElements(node.group)
      if (node == null) {
        index = dflt_grouping_choices.indexOf(grouping_choice);
        this.data = this.aggr(dflt_grouping_choices, index, this.list);//
        this.data.sort((a, b) => {
          return (
              a[sortProp] -
              a[sortProp]
          );
        });
        this.group_by = index;
      } else {
        index = node.data.grouping_choices.indexOf(grouping_choice);
        this.$set(node, "expanded", true);
        if (node.data.groupings[grouping_choice].length == 1) {
          return;
        }
        let parent_labels = node.data.parent_labels.slice();
        parent_labels.push(node.data.label);
        node.data.children = this.aggr(
            node.data.grouping_choices,
            index,
            node.data.group,
            parent_labels
        );
        if (
            node.data.group_by_parent === "loc_code" ||
            node.data.group_by_parent === "pp_name" ||
            node.data.group_by_parent === "routeNum"
        ) {
          node.data.children.sort((a, b) => {
            return (
                a[sortProp] -
                b[sortProp]
            );
          });
        } else {
          node.data.children.sort((a, b) => {
            return b.pax - a.pax;
          });
        }
        node.data.group_by_name = node.data.grouping_choices[index];
        node.data.group_by = index;
      }
    }
    ,

    setSequences(data) {
      let rts_seq = {};
      const vm = this
      data = data.map(bk => {
        let rt_seq = rts_seq[bk.routeNum] ? rts_seq[bk.routeNum] : {locs_seq: [], pup_seq: []}
        let locs_seq = rt_seq.locs_seq, pup_seq = rt_seq.pup_seq
        let hi_seq = locs_seq.indexOf(bk.loc_code)
        if (hi_seq >= 0) hi_seq = (hi_seq + 1) * 1000
        else {
          locs_seq.push(bk.loc_code)
          hi_seq = locs_seq.length * 1000
        }
        let low_seq = pup_seq.indexOf(bk.pp_name)
        if (low_seq >= 0) low_seq = (low_seq + 1)
        else {
          pup_seq.push(bk.pp_name)
          low_seq = pup_seq.length
        }
        // bk = vm.getTheRightTime(bk)
        bk.routeSeq = hi_seq + low_seq
        rt_seq.locs_seq = locs_seq
        rt_seq.pup_seq = pup_seq
        rts_seq[bk.routeNum] = rt_seq
        //_log_('ndchildNodes ---setSequences', vm.intToTime(bk.starting_time), bk.starting_time, bk.routeSeq, bk.loc_code, bk.pp_name)
        return bk
      });
      return data
    },
    async loadSeqPatterns() {
      _log_('loadSeqPatterns....')
      this.autoRouting = !this.autoRouting
      if (!this.autoRouting) return
      const msg = this.$message({
        message: 'Loading A.I. information for routes, please wait.',
        type: 'warning',
        duration: 10000000
      });
      predictedSeqs = sessionStorage.getItem("predictedSeqs")
      predictedSeqs = JSON.parse(predictedSeqs)
      if (!predictedSeqs) {
        this.loading = true
        const {data} = await api.fetchProcessor("vue_route/autocomposer", {

          do: "get_seqs",

        });
        predictedSeqs = data.results
        sessionStorage.setItem("predictedSeqs", JSON.stringify(predictedSeqs));
        this.loading = false
      }
      msg.close()
      return
      // const data = await api.fetchProcessor("route/undo", {
      //
      //   do: "undo",
      //   // base_route: base_route//dropNode.parent.data.parent_labels[0],
      // });
    }
    ,
    async undoMove() {
      _log_('undo....')
      this.flushingRoutes = true
      // return
      const {data} = await api.fetchProcessor("route/undo", {

        do: "undo",
        _act_group: this.getActGroup()
      });
      this.undoCount = data.undoMovesLeft
      this.$emit('refresh')
      this.flushingRoutes = false
    },
    async getUndoMovesCount() {


      // return
      const {data} = await api.fetchProcessor("route/undo", {

        do: "undo_moves_count",
        _act_group: this.getActGroup()
      });
      this.undoCount = data.undoMovesLeft
      _log_('undo..getUndoMovesCount..',      this.undoCount)

    },
    findRouteOverlaps(specific_routeNum, loud) {
      let routeNums = [], problems = []
      if (specific_routeNum) routeNums = [specific_routeNum]
      else this.list.forEach(b => b.routeNum && !routeNums.includes(b.routeNum) ? routeNums.push(b.routeNum) : null)
      routeNums.forEach(routeNum => {
        const times = getTimeRanges(this.list.filter(b => b.routeNum == routeNum))
        const newProblems = findOverlappingRanges(times);

        if (newProblems?.length) {
          problems = [...problems, ...newProblems]
          _log_('findRouteOverlaps newProblems', newProblems)
          let locs = []
          newProblems.forEach(c => {
            if (!locs.includes(c.conflictLoc)) locs.push(c.conflictLoc)
            c.bks.forEach(bk_data => {
              bk_data._warnings = {_time_conflicts_: 'There are conflicts with other pickup times ' + c.conflictLoc}
              // bk_data._warn_title = 'There are conflicts with other pickup times ' + c.conflictLoc
              // bk_data.note__warnings = bk_data._warnings
              bk_data._hasWarning = true
            })
          })

          if (loud) this.$notify.error({
            title: "Times don't look nice",
            message: 'please check: ' + locs.join(','),
            duration: 8000
          });

        }
      })
      return problems.length ? problems : null
      // return null
    }
    ,
    getActGroup() {
      return this.$route.query.date.split('/').reverse().map(n => n * 1 < 10 ? '0' + n : n).join('');
    },
    async updateRoutes(routeData, silent) {
      _log_('updateRoutes', routeData)
      // if(!routeData.bookings?.[0])
      // {
      //   alert('route data are corrupted , try to reload the page')
      // }
      if (routeData.bookings) {

        if (routeData.bookings?.[0]) {
          _log_("updatebookings validate", routeData.bookings);
          if (routeData.base_route && routeData.bookings[0].tripType !== 'ARV') {
            this.findRouteOverlaps(routeData.base_route, true)

          }
        } else alert('route data are corrupted , try to reload the page')
        routeData.bookings = JSON.stringify(routeData.bookings)
      }
      routeData._undokey = Math.floor((new Date()).getTime() / 1000)
      routeData._act_group = this.getActGroup()
      this.flushingRoutes = true
      // if (routeData.bookings) routeData.bookings = JSON.stringify(routeData.bookings)
      const data = await api.fetchProcessor("vue_route/updatebookings", routeData)


      if (!silent && data?.data?.problems) {
        _log_("updatebookings validate AF", data?.data);
        this.notifyProblems(data.data)
      }
      this.unrouted_selected_pax = 0
      this.selected_routed_pax = 0
      this.$nextTick(() =>
          this.flushingRoutes = false)
      this.getUndoMovesCount()
      return data
    },
    createBestSeq(bookings, baseBookings) {
      _log_('createBestSeq..??.INCOMING..', bookings, baseBookings)
      const reverseFactor = this.wTripTypes === 'ARV' ? -1 : 1
      let seqKeys = {}, locKey = [], fullPupsKey = []
      if (!bookings) {
        let ptarget = this.findInArray(this.data, {routeNum: this.lastRouteUpdated})
        bookings = ptarget.group
      }

      const findBestMuch = (key_arr, repo) => {
        key_arr = key_arr.sort((a, b) => a - b)
        let bestSec = null, best_pop_match = null

        _log_('findBestMuch.zz..locKey..INIT.TRY.', key_arr)
        let key_arr_str = key_arr.join('|')
        bestSec = repo[key_arr_str]
        if (!bestSec) {
          for (const repoKey in repo) {
            const repoData_key = repo[repoKey]._key
            const commonTokens = repoData_key.filter(token => key_arr.includes(token));
            if (commonTokens?.length) {
              let pop_match = key_arr_str.length - commonTokens.length
              if (pop_match === 0) {
                bestSec = repo[repoKey]
                break
              } else if (best_pop_match === null || best_pop_match > pop_match) {
                best_pop_match = pop_match
                bestSec = repo[repoKey]
              }
            }
          }
        }

        return bestSec
      }

      let stmpBookings = [], idx = 1
      if (baseBookings) baseBookings.forEach(bk => {
        bk._base = true
        bk._order = ++idx
        if (bk.group)
          _log_('createBestSeq..??.baseBookings..', bk)
        stmpBookings.push(bk)
      })
      if (bookings) bookings.forEach(bk => {
        if (bookings)
          bk._base = false
        if (bk.group)
          _log_('createBestSeq..??.bookings..', bk)
        stmpBookings.push(bk)
      })

      stmpBookings.forEach(bk => {
        if (!locKey.includes(bk.loc_id)) locKey.push(bk.loc_id)
        if (!fullPupsKey.includes(bk.pp_id)) fullPupsKey.push(bk.pp_id)
        if (!seqKeys[bk.loc_id]) seqKeys[bk.loc_id] = {}
        if (!seqKeys[bk.loc_id].pupKey) seqKeys[bk.loc_id].pupKey = []
        if (!seqKeys[bk.loc_id].pupKey.includes(bk.pp_id)) seqKeys[bk.loc_id].pupKey.push(bk.pp_id)
        seqKeys[bk.loc_id].pupKey = seqKeys[bk.loc_id].pupKey.sort((a, b) => a - b)
        seqKeys[bk.loc_id][bk.pp_id] = {
          finalPickupTime: bk.finalPickupTime,
          starting_time: bk.starting_time,
          routeSeq: bk.routeSeq,
          _base: !!bk._base
        }
      })
      // fullPupsKey = [...seqKeys[locid].pupKey]
      let bestLocRoute = findBestMuch(locKey, predictedSeqs.locs)

      fullPupsKey = fullPupsKey.sort((a, b) => a - b)
      let secsByLoc = {}
      if (fullPupsKey.length > 1) {
        let pupKey_str = fullPupsKey.join('|')
        let bestPupSec = predictedSeqs.pups[pupKey_str]
        if (!bestPupSec) {
          for (const locid in seqKeys) if (seqKeys[locid].pupKey.length > 1) {
            fullPupsKey = [...seqKeys[locid].pupKey]
            bestPupSec = findBestMuch(fullPupsKey, predictedSeqs.pups)
            if (bestPupSec) secsByLoc[locid] = Object.keys(bestPupSec)[0].split(',')
            _log_('target.zz..bestPupSec...locKey FOR LOC..', locid, bestPupSec)
          }
        } else secsByLoc._all = Object.keys(bestPupSec)[0].split(',');

      }
      //?.map(l => predictedSeqs.locs_idx[l])
      if (bestLocRoute)
        _log_('createBestSeq.LOCS.', bestLocRoute.optimal.map(l => predictedSeqs.locs_idx[l]).join('-'))
      // _log_('createBestSeq.zz..locKey...secsByLoc..', secsByLoc)
      stmpBookings.forEach(bk => {
        let seqWeight = 0
        _log_('createBestSeq.stmpBookings..ABOUT..', bk.ppname)
        if (bestLocRoute?.optimal) {
          const indexOfLoc = bestLocRoute.optimal.indexOf(bk.loc_id);
          seqWeight += (indexOfLoc >= 0 ? indexOfLoc + 1 : 0) * 1000
          _log_('--->createBestSeq.BY OPTIMAL.loc.', bk.loc_code, seqWeight, bk.loc_id, bestLocRoute.optimal)
        }
        if (secsByLoc?._all) {
          seqWeight += secsByLoc._all.indexOf(bk.pp_id)
          _log_('--->createBestSeq.BY OPTIMAL.pp....', seqWeight)
        } else if (secsByLoc?.[bk.loc_id]) {
          const indexOfPup = secsByLoc[bk.loc_id].indexOf(bk.pp_id);
          seqWeight += indexOfPup >= 0 ? indexOfPup + 1 : 0
          _log_('--->createBestSeq.BY s  pp..', seqWeight)
          if (indexOfPup < 0 && bk._base) {
            seqWeight += bk._order

          }
        }
        if (seqWeight) {
          bk.routeSeq = bk._order = seqWeight * reverseFactor
          _log_('------>createBestSeq. .IS WΕΙΓΗΤ..', bk.ppname, seqWeight)
        } else {
          bk.routeSeq = bk._order = bk._order * reverseFactor
          // bk._order = bk.routeSeq
          _log_('?????createBestSeq.BASE..locKey...NO WΕΙΓΗΤ..', bk)
        }
      })

      if (['EXCRS', 'ARV'].includes(this.wTripTypes)) return
      stmpBookings = stmpBookings.sort((a, b) => a._order - b._order)

      let nailedTimes = {}, lp = 0

      stmpBookings.forEach(bk => {
        let wT = nailedTimes[bk.pp_id]
        if (!wT)
          wT = {a: 0, z: 0, c: 0}
        if (bk._base) wT.c = bk.starting_time
        if (lp && bk.pp_id != lp) {
          let prev = nailedTimes[lp]
          if (prev) {
            wT.a = prev.c || prev.z
            prev.z = wT.c || wT.a
          }
        }
        lp = bk.pp_id
        nailedTimes[bk.pp_id] = wT
      })
      _log_('createBestSeq.nailedTimes.', nailedTimes)


      ///now create logical times
      let lastTime = stmpBookings[0].starting_time, lastPup_id = stmpBookings[0].pp_id
      stmpBookings.forEach((bk, idx) => {
        _log_('TIME createBestSeq..ABOUT.SET TIME.----------.', bk._order, lastTime, bk.pp_name, bk.starting_time, bk.finalPickupTime, bk)
        if (lastPup_id !== bk.pp_id) {
          lastPup_id = bk.pp_id
          let aLimit = nailedTimes[bk.pp_id]?.a || lastTime,
              zLimit = nailedTimes[bk.pp_id]?.z || 0
          if (!bk._base && !bk.routeNum && (!baseBookings?.length || bk.starting_time <= aLimit || (zLimit && bk.starting_time >= zLimit))) {
            lastTime += 5
            bk.starting_time = lastTime

            bk.finalPickupTime = this.intToTime(bk.starting_time);
            _log_('TIME createBestSeq.FFFFF SET TIME..', bk.pp_name, bk.starting_time, bk.finalPickupTime, bk)
          } else _log_('TIME createBestSeq.SAME TIME..', lastTime, bk.pp_name, bk.starting_time, bk.finalPickupTime, bk)
          lastTime = bk.starting_time * 1

        } else {
          bk.starting_time = lastTime
          _log_('TIME createBestSeq.SAME TIME.SAME PP.', lastTime, bk.pp_name, bk.starting_time, bk.finalPickupTime, bk)
          bk.finalPickupTime = this.intToTime(bk.starting_time);
        }
      })
      // _log_('target.zz..locKey...locKey_str..', predictedSeqs[locKey_str])
    },

    adjustNewSeq: async function (dropNode) {

      const vm = this, base_route = dropNode.data.routeNum;
      let deepResort = false
      locationsTimeTable = {}
      // if (!base_route) {
      //   alert('opa')
      //   return
      // }
      let timesToSorter = [], timesToSort = [], time_i = 0;
      let correction_high = 0, correction_low = 0, transporData = []
      trainBkOrders()
      let workingNode = dropNode
      if (dropNode.level == 3) {
        workingNode = dropNode.parent
        deepResort = true
      }
      workingNode.parent.data.children = workingNode.parent.data.children.map((nd) => {
        _log_('changing nodes...', nd.group_by_parent, nd)
        if (nd.group_by_parent != "loc_code" && nd.group_by_parent != 'pp_name') return nd
        correction_high += 1000
        correction_low = 0
        nd.routeSeq = correction_high
        const loc_code = nd.label
        trainBkOrders(nd, null, nd.label)
        //_log_('trainBkOrders..|.', nd.label)
        // if (deepResort)
        if (nd.children && _.isArray(nd.children)) nd.children = nd.children.map((nd_c) => {
              //_log_('trainBkOrders..>>>>.', correction_high, nd_c.starting_time, nd_c.group_by_name, nd_c.label)
              correction_low += 1
              nd_c.routeSeq = correction_high + correction_low
              if (nd_c.group_by_parent == "pp_name")
                trainBkOrders(nd_c, nd_c.label, loc_code)
              else if (nd_c.label && !nd_c.pp_name && _.isArray(nd_c.children)) {
                nd_c.children = nd_c.children.map(bks => {
                  bks.routeSeq = nd_c.routeSeq
                  if (bks.pp_name && bks.loc_code) trainBkOrders(nd_c, bks.pp_name, bks.loc_code)
                  return bks
                })
              } else trainBkOrders(nd_c, nd_c.pp_name, loc_code)
              // else {
              //   transporData.push(nd_c)
              //   trainBkOrders(nd_c, nd_c.pp_name ? nd_c.pp_name : nd_c.labe, nd.label ? nd.label : nd.loc_code)
              // }
              // let itemH = {
              //   label: nd.data.label
              // };
              // trainBkOrders(nd_c, nd_c.pp_name ? nd_c.pp_name : nd_c.label, nd.label ? nd.label : nd.loc_code)
              return nd_c
            }
        );

        return nd
        // correction += 1
        // let itemH = {
        //   label: nd.data.label
        // };
        // trainBkOrders(correction, nd.data, dropNode.parent)
      });

      _log_("sent.. orders..", bkOrders)
      // return
      // let previoustime = null,
      //     times = JSON.parse(JSON.stringify(timesToSorter.sort((a, b) => a.starting_time - b.starting_time)))
      // correction = 0
      // timesToSorter
      //     .sort((a, b) => a.order - b.order).forEach((tm, ii) => {
      //   timesToSort.push({label: tm.label, starting_time: times[ii].starting_time})
      // })
      // .map((tm) => {
      //   correction += 0.01
      //   //correct in case they have similar time
      //   if (!previoustime) previoustime = tm.starting_time;
      //   else if (previoustime == tm.starting_time) tm.starting_time +=correction;
      //   return tm;
      // });
      // _log_('ndchil000dNodes', times, timesToSort)
      let groupedIn = deepResort ?
          dropNode.parent.data.groupings[dropNode.data.group_by_parent] : workingNode.parent.data.groupings[workingNode.data.group_by_parent];

      workingNode.parent.childNodes = workingNode.parent.childNodes.map((nd) => {
        // _log_('ndchildNodes time_offset', bkOrders, nd.data.starting_time, getBkOrder(nd.data, true), nd.data)
        // _log_('ndchildNodes h time_offset', vm.intToTime(nd.data.starting_time), vm.intToTime(getBkOrder(nd.data, true)), nd.data)
        let time_offset = 0
        if (!deepResort) {
          time_offset = getBkOrder(nd.data, false, true) - nd.data.starting_time;
          if (!this.excrsMode) {
            nd.data.starting_time = getBkOrder(nd.data, false, true);
            nd.data.finalPickupTime = vm.intToTime(nd.data.starting_time);
          }
        }
        // _log_('ndchildNodes seq_offset NODE:', getBkOrder(nd.data), nd.data.routeSeq, nd.data, seq_offset)
        // return nd
        // nd.data.starting_time = getBkOrder(nd.data, true);
        let groupRef = vm.findInArray(groupedIn, {label: nd.data.label});
        if (groupRef) groupRef.starting_time = nd.data.starting_time;
        // nd.data.finalPickupTime = vm.intToTime(nd.data.starting_time);

        ++time_i;
        // const seq_offset = getBkOrder(nd.data) - nd.data.routeSeq

        // _log_('ndchildNodes getBkOrder NODE:', getBkOrder(nd.data), nd.data.routeSeq, nd.data, seq_offset)

        // if (getBkOrder(nd.data) !== false)
        //   nd.data.routeSeq = getBkOrder(nd.data);
        // if (time_offset) {
        nd.data.children = nd.data.children.map((chld) => {

          //_log_('ndchildNodes 0:', chld.label, vm.intToTime(chld.starting_time), time_offset, groupRef)
          if (time_offset && !this.excrsMode) {
            chld.starting_time += time_offset;

            chld.finalPickupTime = vm.intToTime(chld.starting_time);
            chld = this.renderBooking(chld)
          }
          if (deepResort) {
            chld.routeSeq = getBkOrder(chld, true);
            if (!this.excrsMode) {
              chld.starting_time = getBkOrder(chld, true, true);

              chld.finalPickupTime = vm.intToTime(chld.starting_time);
            }
            chld = this.renderBooking(chld)
          }
          return chld
        })
        nd.data.group = nd.data.group.map((chld) => {

          //_log_('ndchildNodes group 0:', chld.label, vm.intToTime(chld.starting_time), time_offset, groupRef)
          if (time_offset && !this.excrsMode) {
            chld.starting_time += time_offset;
            chld.finalPickupTime = vm.intToTime(chld.starting_time);
          }
          if (deepResort) {
            chld.routeSeq = getBkOrder(chld, true);
            if (!this.excrsMode) {
              chld.starting_time = getBkOrder(chld, true, true);
              chld.finalPickupTime = vm.intToTime(chld.starting_time);
            }
            chld = this.renderBooking(chld)
          }
          // //_log_('ndchildNodes 1:', chld.routeSeq, chld.finalPickupTime)
          return chld
        })

        return nd
      });
      groupedIn = groupedIn.sort((a, b) => getBkOrder(a, deepResort) - getBkOrder(b, deepResort));
      // groupedIn = groupedIn.map((a, b) => getBkOrder(a, deepResort) - getBkOrder(b, deepResort)).sort((a, b) => a.routeSeq-b.routeSeq);
      transporData = workingNode.parent.data.group = workingNode.parent.data.group.map(bk => {
        if (!this.excrsMode) {
          bk.starting_time = getBkOrder(bk, true, true);
          bk.finalPickupTime = vm.intToTime(bk.starting_time);
        }
        bk.routeSeq = getBkOrder(bk, true);
        bk = this.renderBooking(bk)
        return bk
      })
          .sort((a, b) => a.routeSeq - b.routeSeq)

      const {data} = await this.updateRoutes({
        bookings: transporData,// JSON.stringify(transporData),
        do: "update_from_bookings",
        base_route: base_route//dropNode.parent.data.parent_labels[0],
      });
      _log_("updatebookings zero", data);
      // if (data?.problems) {
      //   this.notifyProblems(data)
      //
      // }
    }

    ,
    async reOrderTimes(draggingNode, dropNode, dropType, ev) {
      // if(draggingNode.level!=dropNode.level) return;

      if (!draggingNode) return
      if (!dropNode) return
      if (draggingNode.id == dropNode.id) return
      if (!draggingNode.data) return

      // this.loading = true


      //case there in the same area
      if (
          draggingNode.data.group_by_parent == dropNode.data.group_by_parent
          // &&
          // draggingNode.data.label == dropNode.data.label
      ) {
        await this.adjustNewSeq(dropNode);


      }
      // this.loading = false

      let idx = 0;
      // let sentData =dropNode.level==1?dropNode:dropNode.parent
      // sentData =dropNode.level==1?dropNode:dropNode.parent
      // sentData =dropNode.level==1?dropNode:dropNode.parent
      //_log_(' dropNode.parent sentData ', dropNode.parent)
      // let sentData = dropNode.parent.data.group.sort((a, b) => getBkOrder(a) - getBkOrder(b))
      // // if (dropNode.parent.level == 1)
      // //   sentData = this.setSequences(sentData)
      // // else
      // //   sentData = dropNode.parent.data.group.sort((a, b) => getBkOrder(a) - getBkOrder(b))
      // sentData.forEach(e => {
      //
      //   // e.routeSeq = getBkOrder(e);
      //
      //   //_log_('ndchildNodes ---sentData', vm.intToTime(e.starting_time), e.starting_time, e.routeSeq, e.loc_code, e.pp_name)
      //   return e
      // })


    }
    ,
    async handleDrop(draggingNode, dropNode, dropType, ev) {
      return true;

      // _log_('sent..handle drop.', data)
      // this.lastRouteUpdated = data.routename
    }
    ,
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.level != dropNode.level) return false
      var matched_labels = (arr, target) =>
          target.every((v, i) => arr[i] === v);
      if (
          type !== "inner" &&
          draggingNode.data.parent_labels.length ==
          dropNode.data.parent_labels.length &&
          matched_labels(
              draggingNode.data.parent_labels,
              dropNode.data.parent_labels
          ) == true
      ) {
        // //_log_("Allowed Drop", draggingNode.data.parent_labels, dropNode.data.parent_labels);
        return true;
      }
      // //_log_("Not allowed Drop");
      return false;
    }
    ,
    allowDrag(draggingNode) {
      if (
          draggingNode.parent != null &&
          ((draggingNode.parent.data.group_by_parent == "loc_code" &&
                  draggingNode.data.group_by_parent == "pp_name") ||
              (draggingNode.parent.data.group_by_parent == "routeNum" &&
                  draggingNode.data.group_by_parent == "loc_code") ||
              (draggingNode.parent.data.group_by_parent == "routeNum" &&
                  draggingNode.data.group_by_parent == "pp_name"))
      ) {
        // //_log_("Allowed Drag");
        return true;
      }
      // //_log_("Not allowed Drag");
      return false;
    }
    ,
    resetBooking(bk) {
      bk["routeNum"] = "";
      bk["route_asset_id"] = "";
      bk["route_driver_contact_id"] = "";
      bk["routeSeq"] = 0;
      bk["bussign"] = "";
      bk['finalPickupTime'] = bk['trip_time_human']
      // if (bk.tripType == 'DEP') bk["bookedTimeMM"] = bk['finalPickupTime']//not good temp
      bk['starting_time'] = this.strTimeToInt(bk['trip_time_human'])
      return bk
    },
    async unrouteBookings(e) {


      let i, j, bookingListToGo = [];
      let checkedNodes = this.getBookingsFromCheckedNodes();

      if (checkedNodes?.length) {

        for (let i = 0; i < checkedNodes.length; i++) {
          let checkedNodeToGo = checkedNodes[i];
          if (checkedNodeToGo.bk_id != null) {
            checkedNodeToGo = this.resetBooking(checkedNodeToGo)
            bookingListToGo.push(checkedNodeToGo);
          }
        }


      }
      const {data} = await this.updateRoutes({
        bookings: bookingListToGo,// JSON.stringify(bookingListToGo),
        do: "remove_from_bookings",
        base_route: "",
      });
      this.renderUnrouted(bookingListToGo)
      this.reportBookingsChange()
    },
    renderUnrouted(bookingList = []) {
      const re_columns = [];
      // let bookingList = [];
      // this.data = null;
      // this.unrouted_data = null;
      this.checkedNodes = false;
      this.checkedRoutes = false;
      this.allUnroutedSelected = false;
      this.selected_routed_pax = 0
      // this.total_pax = 0;
      this.unrouted_selected_pax = 0;
      if (bookingList?.length)
        Array.prototype.push.apply(this.unrouted_bookings, bookingList);
      if (!this.unrouted_bookings?.length) return
      this.unrouted_wr_trips = getwr_trips(this.unrouted_bookings);
      this.unrouted_data = table_dataset_conversion(
          this.unrouted_bookings,
          this.unrouted_wr_trips
      );
      _log_('0 this.unrouted_data ', this.unrouted_data, this.unrouted_wr_trips)
      re_columns.push({
        name: "resorts",
        required: true,
        label: "Resorts",
        align: "left",
        field: (row) => row.label,
        format: (val) => `${val}`,
        sortable: true,
        classes: "bg-grey-2 ellipsis",
        style: "",
        headerStyle:
            "background:  rgb(0, 150, 136); color: white; font-size: 14px; min-width: 200px;",
      });
      re_columns.push({
        name: "total",
        align: "center",
        label: "Total",
        field: "pax",
        sortable: true,
        style: "",
        headerStyle: "color:white; font-size: 14px;",
      });
      let sorted_wr_trips = [];
      for (let flight in this.unrouted_wr_trips) {
        sorted_wr_trips.push(this.unrouted_wr_trips[flight]);
      }
      sorted_wr_trips = sorted_wr_trips.sort((a, b) => {
        _log_('sorted_wr_trips', a, b)
        return a.strip_time - b.strip_time;
      });
      for (let i = 0; i < sorted_wr_trips.length; i++) {
        re_columns.push({
          name: sorted_wr_trips[i].label,
          align: "center",
          label: sorted_wr_trips[i].label,
          field: sorted_wr_trips[i].label,
          sortable: true,
          style: "",
          headerStyle:
              "color:white; font-size: 14px; min-width: 76px;",
        });
        // this.total_pax += sorted_wr_trips[i].pax;
      }
      this.list = this.list.filter((el) => !bookingList.includes(el));
      this.data = this.aggr(dflt_grouping_choices, this.group_by, this.list);
      this.data.sort((a, b) => {
        return (
            a["starting_time"] - b["starting_time"]
        );
      });
      this.columns = re_columns
    }
    ,
    reportBookingsChange() {
      let affectedBookings = []
      if (!this.data && !this.unrouted_bookings) return
      this.data.forEach(rt => rt.group.forEach(bk => affectedBookings.push(bk)))
      this.unrouted_bookings.forEach(bk => affectedBookings.push(bk))
      _log_('reportBookingsChange', affectedBookings)
      this.$emit('update', affectedBookings)
    }
    ,
    notifyProblems(data) {
      const h = this.$createElement;
      let divs = []
      Object.values(data.problems).forEach(pro => {
        pro.forEach(reason => {
          divs.push(h('div', null, reason))
          console.warn("reason createRoute", reason);
        })
      })
      // return
      this.$msgbox({
        title: 'Please check last updated route (' + data.routename + ')',
        message: h('div', null, divs),

      })
    }
    ,
    async createRoute(e) {


      let selectedNodes = [],
          unroutedBookings = [],
          newRouteBookings = this.getBookingsFromCheckedNodes();
      let i, j, newRoute;

      if (this.unrouted_data != null) {
        unroutedBookings = this.popUnroutedBookings();
        Array.prototype.push.apply(this.list, unroutedBookings);
        Array.prototype.push.apply(newRouteBookings, unroutedBookings);
      }
      if (this.autoRouting) this.createBestSeq(newRouteBookings)
      newRouteBookings = newRouteBookings.sort((a, b) => a._order - b._order).map(checkedNode => {
        // _log_("new checkedNodes", predictedSeqs.pups_idx[checkedNode.pp_id], checkedNode._order);
        checkedNode.route_asset_id = null
        checkedNode.route_driver_contact_id = null
        checkedNode.route_published_at = (new Date()).getTime() / 1000
        checkedNode.bussign = null
        if (!checkedNode.routeNum && !this.autoRouting) {
          if (!this.excrsMode || this.alwaysSyncBookedTimes) {
            checkedNode.finalPickupTime = checkedNode.strip_time_on_day ? checkedNode.strip_time_on_day : (checkedNodes.children && checkedNodes.children[0] ? checkedNodes.children[0].strip_time_on_day : checkedNode.finalPickupTime)
            if (checkedNode.finalPickupTime) checkedNode.starting_time = this.strTimeToInt(checkedNode.finalPickupTime)
          } else {
            checkedNode.finalPickupTime = checkedNode.bookedTimeMM
            if (checkedNode.finalPickupTime) checkedNode.starting_time = this.strTimeToInt(checkedNode.finalPickupTime)
          }
        }
        return checkedNode
      })

      this.deepUpdate(newRouteBookings)
      _log_("updatebookings 4", newRouteBookings);

      const {data} = await this.updateRoutes({
        bookings: newRouteBookings,// JSON.stringify(newRouteBookings),
        do: "update_from_bookings",
        base_route: "new",
      });
      // if (data?.problems) {
      //   this.notifyProblems(data);
      //
      // }
      // _log_('sent..new...', data)
      this.lastRouteUpdated = data.routename
      newRoute = data.routename;
      const publishedTime = Object.values(data.results)[0]?.route_published_at
      for (i = 0; i < newRouteBookings.length; i++) {
        newRouteBookings[i]["routeNum"] = newRoute;
        let updateBk = this.findInArray(this.list, {bk_id: newRouteBookings[i].bk_id})
        if (!updateBk) alert('problem')
        else {
          updateBk.routeNum = newRoute
          updateBk.route_published_at = publishedTime
        }
      }

      this.data = this.aggr(dflt_grouping_choices, this.group_by, this.list);
      _log_("updatebookings 4.9", this.data);
      this.data.sort((a, b) => {
        return (
            a["starting_time"] - b["starting_time"]
        );
      });
      this.renderUnrouted()
      this.reportBookingsChange()
    }
    ,
    resetData() {
      this.lastRouteUpdated = null
      last_selected_date = null
      this.selected_routed_pax = 0
      this.unrouted_selected_pax = 0
      last_selected_trips = null
      last_selected_booking_filter = null
      // this.$router.push({query: {date: this.$route.query.date}})
      // this.wTripTypes,
      // this.$route.query.booking_filter,
      // this.$route.query.filter_mode,
    }
    ,
    handleExpantion(node, expanted) {
      const vm = this
      _log_("createRoute vue_route/updatebookings 22", node, expanted)
      if (expanted) {
        this.expandNodes = !!this.expandNodes ? this.expandNodes : []
        this.expandNodes.push(node.id)
      } else if (this.expandNodes) {
        if (!!node.children && _.isArray(node.children)) node.children.forEach((subNd) => {

          if (!!subNd.children && _.isArray(subNd.children)) subNd.children.forEach((sub_subNd) => {
            const ssnd_pos = vm.expandNodes.indexOf(sub_subNd.id)
            if (ssnd_pos >= 0) vm.expandNodes.splice(ssnd_pos, 1)
          })
          const snd_pos = vm.expandNodes.indexOf(subNd.id)
          if (snd_pos >= 0) vm.expandNodes.splice(snd_pos, 1)
        })
        const nd_pos = vm.expandNodes.indexOf(node.id)
        if (nd_pos >= 0) vm.expandNodes.splice(nd_pos, 1)
      }
    },
    getBookingsFromCheckedNodes() {
      if (this.data == null || !this.$refs.tree) return []
      let treeCheckedNodes = this.$refs.tree.getCheckedNodes();
      treeCheckedNodes = treeCheckedNodes ? treeCheckedNodes : []
      let filtered_treeCheckedNodes = [], uniqBkIds = {}
      treeCheckedNodes.forEach(bk => {
        if (bk.bk_id && !uniqBkIds[bk.bk_id]) {
          uniqBkIds[bk.bk_id] = true
          filtered_treeCheckedNodes.push(bk)
        } else if (bk.group) bk.group.forEach(bk_group => {
          if (bk_group.bk_id && !uniqBkIds[bk_group.bk_id]) {
            uniqBkIds[bk_group.bk_id] = true
            filtered_treeCheckedNodes.push(bk_group)
          }
        })
      })
      return filtered_treeCheckedNodes;
    }
    ,
    async pasteNodes(e, targetNode) {
      _log_('pasteNodes...target...target..', targetNode)
      let target = targetNode.data
      this.lastRouteUpdated = target.routename ? target.routename : target.routeNum
      const filtered_treeCheckedNodes = this.getBookingsFromCheckedNodes()
      // let treeCheckedNodes = this.$refs.tree.getCheckedNodes();
      // treeCheckedNodes = treeCheckedNodes ? treeCheckedNodes : []
      // let filtered_treeCheckedNodes = [], uniqBkIds = {}
      // treeCheckedNodes.forEach(bk => {
      //   if (bk.bk_id && !uniqBkIds[bk.bk_id]) {
      //     uniqBkIds[bk.bk_id] = true
      //     filtered_treeCheckedNodes.push(bk)
      //   } else if (bk.group) bk.group.forEach(bk_group => {
      //     if (bk_group.bk_id && !uniqBkIds[bk_group.bk_id]) {
      //       uniqBkIds[bk_group.bk_id] = true
      //       filtered_treeCheckedNodes.push(bk_group)
      //     }
      //   })
      // })
      //lets prepare time maps
      let timePupMap = {}, timeLocMap = {}, maxSeq = 0
      let pastedBookings = [],
          unroutedBookings = [];
      let i, j;
      if (this.unrouted_data != null) {
        unroutedBookings = this.popUnroutedBookings();

      }
      let checkedNodes = [...filtered_treeCheckedNodes,
        ...unroutedBookings], pasted_ids = {}
      if (!checkedNodes?.length) return
      if (this.autoRouting) this.createBestSeq(checkedNodes, target.group)

      function mapTimes(bk, validate) {
        bk.loc_id = bk.loc_id * 1
        bk.pp_id = bk.pp_id * 1
        let locTimeReset = false
        if (validate) for (const locId in timeLocMap) if (locId != bk.loc_id) {

          const times = timeLocMap[locId];
          _log_('pasteNodes...VALID T..', times, bk)
          if (times.min_time < bk.starting_time && times.max_time > bk.starting_time) {
            return times.loc_code
            // const loc_times = timeLocMap[bk.loc_id];
            // locTimeReset = true;
            // if (loc_times) {
            //   bk.finalPickupTime = loc_times.finalPickupTime
            //   bk.starting_time = loc_times.starting_time
            //   bk.routeSeq = loc_times.routeSeq
            // }
          }
        }
        maxSeq = bk.routeSeq && maxSeq < bk.routeSeq ? bk.routeSeq : maxSeq
        timePupMap[bk.pp_id * 1] = {
          finalPickupTime: bk.finalPickupTime,
          starting_time: bk.starting_time,
          routeSeq: bk.routeSeq
        }
        if (!timeLocMap[bk.loc_id * 1] || timeLocMap[bk.loc_id * 1].routeSeq < bk.routeSeq) {
          const existedLoc = timeLocMap[bk.loc_id * 1]
          timeLocMap[bk.loc_id * 1] = {
            loc_code: bk.loc_code,
            finalPickupTime: bk.finalPickupTime,
            starting_time: bk.starting_time,
            routeSeq: bk.routeSeq,
            min_time: !existedLoc?.min_time || existedLoc?.min_time > bk.starting_time ? bk.starting_time : existedLoc?.min_time,
            max_time: !existedLoc?.max_time || existedLoc?.max_time < bk.starting_time ? bk.starting_time : existedLoc?.max_time
          }
        }
        return false
      }

      target.group.forEach(bkData => {
        mapTimes(bkData);
      })

      // _log_('route_asset_id pasteNodes pasteNodes START push', timePupMap)

      for (i = 0; i < checkedNodes.length; i++) {

        let checkedNode = checkedNodes[i];
        checkedNode.route_asset_id = target.route_asset_id
        checkedNode.route_driver_contact_id = target.route_driver_contact_id
        checkedNode.bussign = target.bussign
        const comingFromRouteNum = checkedNode.routeNum || checkedNode.routename
        if (checkedNode.bk_id != null) {
          // pasted_ids[checkedNode.bk_id] = true
          _log_('paste-it pasteNodes', checkedNode, timePupMap, timeLocMap)
          if (!this.excrsMode) {
            if (timePupMap[checkedNode.pp_id * 1]) {

              if (checkedNode.strip_dir == 'DEP') {
                checkedNode.finalPickupTime = timePupMap[checkedNode.pp_id * 1].finalPickupTime
                checkedNode.starting_time = timePupMap[checkedNode.pp_id * 1].starting_time
              }
              checkedNode.routeSeq = timePupMap[checkedNode.pp_id * 1].routeSeq
            } else {
              if (timeLocMap[checkedNode.loc_id * 1]) {

                if (checkedNode.strip_dir == 'DEP') {
                  if (!checkedNode.starting_time || !comingFromRouteNum) {
                    checkedNode.finalPickupTime = timeLocMap[checkedNode.loc_id * 1].finalPickupTime
                    checkedNode.starting_time = timeLocMap[checkedNode.loc_id * 1].starting_time
                  }
                  if (!checkedNode._warnings) this.$set(checkedNode, '_warnings', {})
                  checkedNode._warnings._time_not_set_ = 'The time has been assumed by location, you better check it'
                  checkedNode.note__warnings = checkedNode._warnings
                  checkedNode._hasWarning = true
                }
                checkedNode.routeSeq = ++timeLocMap[checkedNode.loc_id * 1].routeSeq
              } else {
                checkedNode.routeSeq = ++maxSeq
                if (checkedNode.strip_dir == 'DEP') {
                  if (!checkedNode._warnings) this.$set(checkedNode, '_warnings', {})
                  checkedNode._warnings._time_not_set_ = 'Please check the time, because it is just the same time with the departure time'
                  checkedNode.note__warnings = checkedNode._warnings
                  checkedNode._hasWarning = true
                }
                // if (checkedNode.tripType != "EXRS")
                if (!checkedNode.finalPickupTime)
                  checkedNode.finalPickupTime = checkedNode.strip_time_on_day
                checkedNode.starting_time = this.strTimeToInt(checkedNode.finalPickupTime)
              }
            }
          }
          if (checkedNode.tripType == "ARV") {
            checkedNode.finalPickupTime = checkedNode.strip_time_on_day
            checkedNode.starting_time = this.strTimeToInt(checkedNode.finalPickupTime)
            _log_('pasteNodes checkedNode ARV push', checkedNode.finalPickupTime, checkedNode.routeSeq, checkedNode)
          } else if (checkedNode.tripType == "EXCRS") {
            checkedNode.finalPickupTime = checkedNode.bookedTimeMM
            if (checkedNode.finalPickupTime) checkedNode.starting_time = this.strTimeToInt(checkedNode.finalPickupTime)
          }
          const problem_locCode = mapTimes(checkedNode, true)
          if (problem_locCode) {
            checkedNode._warnings._time_conflicts_ = 'Please check the time, there are conflicts with other pickup times'
            // checkedNode.note__warnings = checkedNode._warnings
            checkedNode._hasWarning = true
            this.$notify.error({
              title: "Time conflicts",
              message: 'Please check the times in ' + problem_locCode,
              duration: 8000
            });
          }
          pastedBookings.push(checkedNode);
          _log_('pasteNodes pasteNodes BEFORE push', checkedNode.label, checkedNode.routeSeq, checkedNode)
        }
      }

      pastedBookings = pastedBookings.sort((a, b) => b.routeSeq - a.routeSeq)
      _log_('pasteNodes pasteNodes BEFORE push', pasted_ids, this.list)
      Array.prototype.push.apply(this.list, pastedBookings);//.filter(bk => !pasted_ids[bk.bk_id])
      // this.list = this.setSequences(this.list)
      _log_('pasteNodes pasteNodes after push', this.list)

      // _log_("vue_route/updatebookings 11", pastedBookings)
      const {data} = await this.updateRoutes({
        bookings: pastedBookings,// JSON.stringify(pastedBookings),
        do: "update_from_bookings",
        origin: "paste",
        base_route: target.label,
      });
      _log_("updatebookings pasteNodes", data);
      // if (data?.problems) {
      //   this.notifyProblems(data)
      //
      // }
      //_log_(data);
      for (i = 0; i < pastedBookings.length; i++) {
        pastedBookings[i][target.group_by_parent] = target.label;
      }
      // for (i = 0; i < this.list.length; i++) if (data[this.list[i].bk_id]) this.list[i] = data[this.list[i].bk_id]
      this.data = this.aggr(dflt_grouping_choices, this.group_by, this.list);

      this.sortData(this.lastRouteUpdated)
      this.deepUpdate(targetNode)
      // for (i = 0; i < targetNode.childNodes.length; i++)
      //   await this.adjustNewSeq(targetNode.childNodes[i]);
      // await this.resortAction({node: targetNode})
      // _log_('pasteNodes pasteNodes after push', this.list)
      // this.data.sort((a, b) => {
      //   return (
      //       a["starting_time"] - b["starting_time"]
      //   );
      // });

    }
    ,
    validateBookings() {
    }
    ,
    async loadTheBookings(diff_selected_date, diff_selected_trips, diff_selected_booking_filter) {
      _log_(' $route loadTheBookings', diff_selected_date)
      if (this.form.date == "" || this.form.flight_type == "") {
        alert("Please choose a date and flight type.");
        return;
      }
      this.loading = true
      await this.$store.dispatch('tags/fetch', 'assets')
      this.routeGo({query: {checkedRoutes: null, select_routes: null}})
      let date = this.form.date instanceof Date ?
          (this.form.date.getDate()
                  .toString() +
              "/" +
              (this.form.date.getMonth() + 1).toString() +
              "/" +
              this.form.date.getFullYear()
                  .toString()) : this.form.date;
      // var flight_type = this.form.flight_type;
      this.loading = true;
      this.lastRouteUpdated = null
      this.wr_trips = {};
      this.locs = {};
      this.columns = [];
      this.data = null;
      this.list = [];
      this.unrouted_data = null;
      this.unrouted_bookings = [];
      this.unrouted_wr_trips = {};
      this.checkedNodes = false;
      this.checkedRoutes = false;
      this.allUnroutedSelected = false;
      this.selected_routed_pax = 0;
      this.unrouted_selected_pax = 0;


      // if (diff_selected_date) this.resetData()
      const vm = this
      const {data} = await api.fetchProcessor("vue_booking/getlist", {
        plandate: date,
        // range: [date,
        //   date],
        tripTypes: this.wTripTypes ? this.wTripTypes : this.$route.params.trips,
        booking_filter: this.$route.query.booking_filter,
        filter_mode: this.$route.query.filter_mode,
        limit: 0,
        execStatus: 'notcanceled',
        type: "full",
        meetingPointPriority: this.wTripTypes === 'EXCRS' ? this.meetingPointPriority : false,
        for: "routing",
      });
      let time_correction = 0
      // vm.getTheRightTime()

      //lets init route seq
      // let rts_seq = {};
      this.total_list = data.results// this.setSequences(data.results)
      this.searchBookings(this.$route.query.search)


      if (this.total_list.length > 0) {

        // _log_(this.form);
        this.flight_type = this.form.flight_type;
        this.wr_trips = getwr_trips(this.total_list);
        this.locs = getLocations(this.total_list);

        this.unrouted_bookings = this.total_list.filter((rt) => !rt.routeNum);
        this.list = this.total_list.filter((rt) => !!rt.routeNum);
        this.findRouteOverlaps()
        // this.unrouted_list = this.total_list.slice(0, 10);
        // this.list = this.total_list.filter((obj) => {
        //   return this.unrouted_list.indexOf(obj) == -1;
        // });
        if (this.list.length > 0) {
          //inserted route data
          this.data = this.aggr(
              dflt_grouping_choices,
              this.group_by,
              this.list
          );
          this.data.sort((a, b) => {
            return (
                (a["starting_time"] - b["starting_time"])
            );
          });

          this.toogleTreeExpansion('reset')
        }

        this.renderUnrouted()
        // if (this.unrouted_bookings.length > 0) {
        //   this.unrouted_wr_trips = getwr_trips(this.unrouted_bookings);
        //   this.unrouted_data = table_dataset_conversion(
        //       this.unrouted_bookings,
        //       this.unrouted_wr_trips
        //   );
        //   // _log_('1 this.unrouted_data ', this.unrouted_data)
        //   this.columns.push({
        //     name: "resorts",
        //     required: true,
        //     label: "Resorts",
        //     align: "left",
        //     field: (row) => row.label,
        //     format: (val) => `${val}`,
        //     sortable: true,
        //     classes: "bg-grey-2 ellipsis",
        //     style: "",
        //     headerStyle:
        //         "background: rgb(0, 150, 136); color: white; font-size: 14px; min-width: 200px;",
        //   });
        //   this.columns.push({
        //     name: "total",
        //     align: "center",
        //     label: "Total",
        //     field: "pax",
        //     sortable: true,
        //     style: "",
        //     headerStyle: "color:white; font-size: 14px;",
        //   });
        //   let sorted_wr_trips = [];
        //   for (let flight in this.unrouted_wr_trips) {
        //     sorted_wr_trips.push(this.unrouted_wr_trips[flight]);
        //   }
        //   sorted_wr_trips = sorted_wr_trips.sort((a, b) => {
        //     // _log_('sorted_wr_trips', a, b)
        //     return a.strip_time * 1 - b.strip_time * 1;
        //   });
        //   let scaned_keys = {}
        //   for (let i = 0; i < sorted_wr_trips.length; i++) if (!scaned_keys[sorted_wr_trips[i].label]) {
        //     this.columns.push({
        //       name: sorted_wr_trips[i].label,
        //       align: "center",
        //       label: sorted_wr_trips[i].label,
        //       field: sorted_wr_trips[i].label,
        //       sortable: true,
        //       style: "",
        //       headerStyle:
        //           "color:white; font-size: 14px; min-width: 76px;",
        //     });
        //     scaned_keys[sorted_wr_trips[i].label] = true
        //     // this.total_pax += sorted_wr_trips[i].pax;
        //   }
        // }
      } else {
        // alert("No bookings")
      }
      this.$nextTick(() => this.loading = false)

    }
    ,
    onCancel() {
      this.form.date = "";
      this.form.flight_type = "";

    }
    ,
    checked_cell(row, col_flight, colSelected_full, from_src) {
      _log_('checked_cell')
      let from = null;

      let booking = null
      let rowPax = row[col_flight];
      if (from_src && from_src.bk_id)//this means that is restricted in specific booking
      {
        from = 'booking'
        booking = from_src
        if (!booking._selected) {
          this.$set(booking, '_selected', true)
          rowPax = booking.pax
        } else {
          this.$set(booking, '_selected', false)
          rowPax = -booking.pax
        }
      } else {

        from = from_src
      }
      _log_("Canceled!", row, col_flight, colSelected_full, from);
      // const rowPax = booking ? booking.pax : row[col];
      if (rowPax == 0) return;
      if (colSelected_full == null) {


        if (from == 'booking') {
          const some = this.findAllInArray(row.bookings, {_selected: true})
          colSelected_full = some.length == row.bookings.length
        } else {
          colSelected_full = !row.selected[col_flight]
          rowPax = 0
          row.bookings.map(bk => {
            if (bk.for_trip != col_flight) return
            if (colSelected_full) {
              if (!bk._selected)
                rowPax += bk.pax
            } else rowPax += bk.pax
            this.$set(bk, '_selected', colSelected_full)
            return bk
          })
          if (!colSelected_full) rowPax = -rowPax
        }
      }


      let i, flight;
      this.$set(row.selected, col_flight, colSelected_full);
      if (from == 'row') row.bookings.map(bk => {
        this.$set(bk, '_selected', colSelected_full)
        return bk
      })
      if (from != 'booking')
        row.bookings.map(bk => {
          if (bk.for_trip != col_flight) return
          if (colSelected_full) {
            if (!bk._selected)
              rowPax += bk.pax
          } else rowPax += bk.pax
          this.$set(bk, '_selected', colSelected_full)
          return bk
        })
      if (from != "row") {
        // Update Row!
        if (colSelected_full == false) {
          this.$set(row, "selected_group", false);
        } else {
          let all_checked = true;
          for (flight in this.unrouted_wr_trips) {
            if (row.selected[flight] != true && row[flight] > 0) {
              all_checked = false;
              break;
            }
          }
          if (all_checked == true) {
            this.$set(row, "selected_group", true);
          }
        }
        // Update children!
        if (row.children != null) {
          for (i = 0; i < row.children.length; i++) {
            if (row.children[i][col_flight] > 0) {
              if (colSelected_full != true && row.children[i].selected[col_flight] == true) {
                // this.unrouted_selected_pax -= row.children[i][col_flight];
              } else if (
                  colSelected_full == true &&
                  row.children[i].selected[col_flight] != true
              ) {
                _log_("adding children", row.children[i][col_flight]);
                // this.unrouted_selected_pax += row.children[i][col_flight];
              }
            }
            this.checked_cell(row.children[i], col_flight, colSelected_full, "cell");
          }
        }

        _log_('now changed...', this.unrouted_selected_pax)
        // Update Parent's cell.
        if (from != "cell") {
          // if (row.children == null) {
          //   // this.unrouted_selected_pax += rowPax
          //   // if (colSelected_full != true && row.selected[col] != true) {
          //   //   this.unrouted_selected_pax -= rowPax;
          //   // } else if (colSelected_full == true && row.selected[col] == true) {
          //   //   _log_("adding node", rowPax);
          //   //   this.unrouted_selected_pax += rowPax;
          //   // }
          // }
          if (row.parent != null) {
            if (colSelected_full == false) {
              this.$set(row.parent.selected, col_flight, false);
              this.$set(row.parent, "selected_group", false);
            } else {
              for (i = 0; i < row.parent.children.length; i++) {
                if (
                    row.parent.children[i].selected[col_flight] != true &&
                    row.parent.children[i][col_flight] > 0
                ) {
                  break;
                }
              }
              if (i == row.parent.children.length) {
                this.$set(row.parent.selected, col_flight, true);
              }
              let all_checked = true;
              for (flight in this.unrouted_wr_trips) {
                if (
                    row.parent.selected[flight] != true &&
                    row.parent[flight] > 0
                ) {
                  all_checked = false;
                }
              }
              if (all_checked == true) {
                this.$set(row.parent, "selected_group", true);
              }
            }
          }
          // Update Column's label.
          if (from != "col") {
            if (colSelected_full == false) {
              this.checked_col(col_flight, false);
              this.checked_all(false);
            } else {
              for (i = 0; i < this.unrouted_data.length; i++) {
                if (
                    this.unrouted_data[i].selected[col_flight] != true &&
                    this.unrouted_data[i][col_flight] > 0
                ) {
                  break;
                }
              }
              if (i == this.unrouted_data.length) {
                this.checked_col(col_flight, true);
              }
              let all_checked = true;
              for (flight in this.unrouted_wr_trips) {
                if (
                    this.unrouted_wr_trips[flight].selected_group != true &&
                    this.unrouted_wr_trips[flight].pax > 0
                ) {
                  all_checked = false;
                }
              }
              if (all_checked == true) {
                this.checked_all(true);
              }
            }
            this.handleCheckChange();
          }
        }

      }
      this.unrouted_selected_pax = this.unrouted_data.reduce((rowSum, dat) => rowSum + dat.bookings.reduce((bkSum,
                                                                                                            bk) => bkSum + (bk._selected ? 1 * bk.pax : 0), 0), 0)

    }
    ,
    checked_row(row, value) {
      _log_('checked_row')
      let recursive = true;
      if (value == null) {
        value = !row.selected_group;
        recursive = false;
      }

      let i, j, flight;
      this.$set(row, "selected_group", value);
      for (flight in this.unrouted_wr_trips) {
        // if (row[flight] > 0 && row.children == null) {
        //   if (value != true && row.selected[flight] == true) {
        //     this.unrouted_selected_pax -= row[flight];
        //   }
        //   else if (value == true && row.selected[flight] != true) {
        //     this.unrouted_selected_pax += row[flight];
        //   }
        // }
        this.checked_cell(row, flight, value, "row");
      }
      if (row.children != null) {
        for (i = 0; i < row.children.length; i++) {
          this.checked_row(row.children[i], value);
        }
      }
      if (!recursive) {
        if (row.parent != null) {
          if (value == false) {
            this.$set(row.parent, "selected_group", false);
            for (flight in this.unrouted_wr_trips) {
              if (row[flight] > 0) {
                this.$set(row.parent.selected, flight, false);
              }
            }
          } else {
            let selected_parent = true;
            for (flight in this.unrouted_wr_trips) {
              if (row[flight] > 0 && row.parent.selected[flight] != true) {
                for (i = 0; i < row.parent.children.length; i++) {
                  if (
                      row.parent.children[i].selected[flight] != true &&
                      row.parent.children[i][flight] > 0
                  ) {
                    break;
                  }
                }
                if (i == row.parent.children.length) {
                  this.$set(row.parent.selected, flight, true);
                } else {
                  selected_parent = false;
                }
              } else if (
                  row.parent[flight] > 0 &&
                  row.parent.selected[flight] != true
              ) {
                selected_parent = false;
              }
            }
            this.$set(row.parent, "selected_group", selected_parent);
          }
        }
        if (value == false) {
          this.checked_all(false);
          for (flight in this.unrouted_wr_trips) {
            if (row[flight] > 0) {
              this.checked_col(flight, false);
              if (row.parent != null) {
                this.checked_cell(row, flight, false, "row");
              }
            }
          }
        } else {
          let all_checked = true;
          for (flight in this.unrouted_wr_trips) {
            if (row[flight] > 0) {
              for (j = 0; j < this.unrouted_data.length; j++) {
                if (
                    this.unrouted_data[j].selected[flight] != true &&
                    this.unrouted_data[j][flight] > 0
                ) {
                  break;
                }
              }
              if (j == this.unrouted_data.length) {
                this.checked_col(flight, true);
              }
            }
            if (
                this.unrouted_wr_trips[flight].selected_group != true &&
                this.unrouted_wr_trips[flight].pax > 0
            ) {
              all_checked = false;
            }
          }
          if (all_checked == true) {
            this.checked_all(true);
          }
        }
        this.handleCheckChange();
      }
    }
    ,
    checked_col(col, value) {
      _log_('checked_col')
      let recursive = true;
      if (value == null) {
        value = !this.unrouted_wr_trips[col].selected_group;
        recursive = false;
      }

      let i, flight;
      this.$set(this.unrouted_wr_trips[col], "selected_group", value);
      if (!recursive) {
        for (i = 0; i < this.unrouted_data.length; i++) {
          this.checked_cell(this.unrouted_data[i], col, value, "col");
        }
        if (value == false) {
          this.checked_all(false);
        } else {
          let all_checked = true;
          for (flight in this.unrouted_wr_trips) {
            if (
                this.unrouted_wr_trips[flight].selected_group != true &&
                this.unrouted_wr_trips[flight].pax > 0
            ) {
              all_checked = false;
              break;
            }
          }
          if (all_checked == true) {
            this.checked_all(true);
          }
        }
        this.handleCheckChange();
      }
    }
    ,
    checked_all(value) {
      _log_('checked_all')
      let recursive = true;
      if (value == null) {
        value = !this.allUnroutedSelected;
        recursive = false;
      }

      let i, flight;
      this.$set(this, "allUnroutedSelected", value);
      if (!recursive) {
        for (i = 0; i < this.unrouted_data.length; i++) {
          this.checked_row(this.unrouted_data[i], value);
        }
        for (flight in this.unrouted_wr_trips) {
          this.checked_col(flight, value);
        }
        this.handleCheckChange();
      }
    }
    ,
    getSelectedBookings() {
      getSelected_UnroutedBookings(
          this.unrouted_data,
          this.unrouted_bookings,
          this.allUnroutedSelected
      );
      // _log_("Selected: ", selected_bookings);
      // _log_("Not Selected: ", this.unrouted_list.filter(obj => { return selected_bookings.indexOf(obj) == -1; }));
      _log_(this.unrouted_data);
      return getSelected_UnroutedBookings(
          this.unrouted_data,
          this.unrouted_bookings,
          this.allUnroutedSelected
      );
    }
    ,
    popUnroutedBookings() {

      let selected_bookings = [];
      if (this.allUnroutedSelected == true) {
        Array.prototype.push.apply(selected_bookings, this.unrouted_bookings);
        // this.total_pax = 0;
        this.unrouted_bookings = [];
        this.allUnroutedSelected = false;
        this.unrouted_wr_trips = {};
        this.columns = [];
        this.$set(this, "unrouted_data", []);
        this.unrouted_data = null;
      } else {
        // _log_('selected_bookings...1..', this.unrouted_wr_trips, this.unrouted_data)
        let bks_idx, hotel_idx, wbk_idx, flight, col_idx;
        let popedBooking;
        if (this.unrouted_data?.length)
          for (bks_idx = 0; bks_idx < this.unrouted_data.length; bks_idx++) {
            const location = this.unrouted_data[bks_idx];
            if (location.selected_group == true) {

              Array.prototype.push.apply(
                  selected_bookings,
                  location.bookings
              );
              for (flight in this.unrouted_wr_trips) {
                if (location[flight] > 0) {
                  this.unrouted_wr_trips[flight].pax -= location[
                      flight
                      ];
                  if (this.unrouted_wr_trips[flight].pax == 0) {
                    delete this.unrouted_wr_trips[flight];
                    for (col_idx = 0; col_idx < this.columns.length; col_idx++) {
                      if (this.columns[col_idx].label === flight) {
                        this.columns.splice(col_idx, 1);
                        break;
                      }
                    }
                  } else {
                    this.unrouted_wr_trips[flight].selected_group = false;
                  }
                }
              }
              // this.total_pax -= location.pax;
              this.unrouted_bookings = this.unrouted_bookings.filter((obj) => {
                return location.bookings.indexOf(obj) == -1;
              });

              if (this.total_pax == 0) {
                this.unrouted_data = null;
              } else {
                this.unrouted_data.splice(bks_idx, 1);
                bks_idx--;
              }
            } else {
              const hotels = location.children;
              if (hotels != null) {
                for (hotel_idx = 0; hotel_idx < hotels.length; hotel_idx++) {
                  const hotel = hotels[hotel_idx];
                  let w_bookings = this.findAllInArray(hotel.bookings, {_selected: true});
                  // _log_('selected_bookings...200..', hotel)
                  let unselect_w_bookings = this.findAllInArray(hotel.bookings, {_selected: false});
                  // if (!w_bookings) continue
                  // w_bookings = this.findAllInArray(w_bookings, {_selected: true})

                  // w_bookings = haRestricions ? haRestricions : w_bookings
                  let hotel_selected_pax = 0;
                  if (w_bookings.length) {
                    _log_('selected_bookings...200.w_bookings.', w_bookings)
                    Array.prototype.push.apply(
                        selected_bookings,
                        w_bookings
                    );
                    for (flight in this.unrouted_wr_trips) {
                      if (hotel[flight] > 0 && hotel.selected && hotel.selected[flight]) {
                        _log_('selected_bookings...-PAXs.unrouted_wr_trips.', flight, this.unrouted_wr_trips[flight], this.unrouted_wr_trips)
                        this.unrouted_wr_trips[flight].pax -= hotel[flight];
                        if (this.unrouted_wr_trips[flight].pax == 0) {
                          delete this.unrouted_wr_trips[flight];
                          for (col_idx = 0; col_idx < this.columns.length; col_idx++) {
                            if (this.columns[col_idx].label === flight) {
                              this.columns.splice(col_idx, 1);
                              break;
                            }
                          }
                        } else {
                          this.unrouted_wr_trips[flight].selected_group = false;
                        }

                        location[flight] -= hotel[flight];
                        location.selected[flight] = false;
                      }
                    }

                    hotel_selected_pax = 0
                    hotel.bookings = hotel.bookings.filter((bk) => !this.findInArray(w_bookings, {bk_id: bk.bk_id}));
                    this.unrouted_bookings = this.unrouted_bookings.filter((bk) => {
                      if (!this.findInArray(w_bookings, {bk_id: bk.bk_id})) {
                        hotel_selected_pax += bk.pax
                        return true
                      }
                    });

                    // _log_('selected_bookings...200.hotel_selected_pax.', location)
                    // this.total_pax -= hotel_selected_pax;
                    location.pax -= hotel_selected_pax;
                    if (this.total_pax == 0) {
                      // _log_('selected_bookings...1.total_pax.', location)
                      this.unrouted_data = null;
                    } else if (location.pax == 0) {
                      // _log_('selected_bookings...1.location.pax.', location)
                      this.unrouted_data.splice(bks_idx, 1);
                      bks_idx--;
                    } else {
                      location.bookings = location.bookings.filter((bk) => !this.findInArray(w_bookings, {bk_id: bk.bk_id}));
                      // _log_('selected_bookings...1. location.bookings.pax.', hotel, location, location.bookings)
                      if (!hotel.bookings.length) {
                        hotels.splice(hotel_idx, 1);
                        hotel_idx--;
                      }
                    }
                  }
                  if (unselect_w_bookings.length) {
                    _log_('something poped unselect_w_bookings')
                    popedBooking = false;
                    for (
                        wbk_idx = 0;
                        wbk_idx < w_bookings.length;
                        wbk_idx++
                    ) {
                      let wBooking = w_bookings[
                          wbk_idx
                          ];
                      if (
                          hotel.selected[
                              wBooking
                                  .for_trip
                              ] == true
                      ) {
                        // _log_('selected_bookings...3.', wBooking)
                        selected_bookings.push(
                            wBooking
                        );

                        let unroutedWrTripPax = this.unrouted_wr_trips[
                            wBooking.for_trip
                            ];
                        if (unroutedWrTripPax) {
                          unroutedWrTripPax.pax -= wBooking.pax;
                          if (
                              unroutedWrTripPax.pax === 0
                          ) {
                            delete this.unrouted_wr_trips[
                                wBooking
                                    .for_trip
                                ];
                            for (col_idx = 0; col_idx < this.columns.length; col_idx++) {
                              if (
                                  this.columns[col_idx].label ===
                                  wBooking
                                      .for_trip
                              ) {
                                this.columns.splice(col_idx, 1);
                                break;
                              }
                            }
                          } else {
                            unroutedWrTripPax.selected_group = false;
                          }
                        }

                        _log_('location?????', location, hotel)
                        location[
                            wBooking.for_trip
                            ] -= wBooking.pax;
                        location.selected[
                            wBooking.for_trip
                            ] = false;

                        hotel[
                            wBooking.for_trip
                            ] -= wBooking.pax;

                        // this.total_pax -= w_bookings[k].pax;
                        location.pax -= wBooking.pax;
                        hotel.pax -= wBooking.pax;

                        this.unrouted_bookings = this.unrouted_bookings.filter((obj) => {
                          return (
                              obj.bk_id !=
                              wBooking.bk_id
                          );
                        });
                        location.bookings = location.bookings.filter((obj) => {
                          return (
                              obj.bk_id !=
                              wBooking.bk_id
                          );
                        });
                        // w_bookings.splice(k, 1);
                        const pos = this.findInArray(hotel.bookings, {bk_id: wBooking.bk_id})
                        hotel.bookings.splice(pos, 1);
                        // k--;
                      }
                    }
                    if (popedBooking == true) {
                      for (flight in this.wr_trips) {
                        if (hotel.flight == 0) {
                          hotel.selected[
                              flight
                              ] = false;
                        }
                      }
                      if (this.total_pax == 0) {
                        this.unrouted_data = null;
                      } else if (location.pax == 0) {
                        this.unrouted_data.splice(bks_idx, 1);
                        bks_idx--;
                      } else if (hotel_selected_pax == 0) {
                        hotel.splice(hotel_idx, 1);
                        hotel_idx--;
                      }
                    }
                  }

                }
              }
            }
          }
      }
      this.unrouted_selected_pax = 0;
      // this.unrouted_data=   rowDataSorter(  this.unrouted_data)
      // _log_('  this.unrouted_data selected_bookings,', this.unrouted_data, selected_bookings);
      // let temp = 0;
      // for(let i=0; i<selected_bookings.length; i++) {
      // 	temp += selected_bookings[i].pax;
      // }
      // _log_(temp);
      return selected_bookings.map(bk => {
        if (bk.tripType == 'EXCRS') {
          this.$set(bk, 'finalPickupTime', bk.bookedTimeMM)
          if (bk.finalPickupTime)
            this.$set(bk, 'starting_time', this.strTimeToInt(bk.finalPickupTime))
        }
        bk._selected = false
        return bk
      });
    }
    ,
    async routeDriveUpdate(node, prop) {
      let routeData = {}

      if (prop == 'bussign') routeData.bussign = node.data.bussign
      else {
        routeData.route_asset_id = node.data.route_asset_id
        routeData.route_driver_contact_id = node.data.route_driver_contact_id
      }
      let routeNum;
      if (node.data.parent_labels.length == 0) {
        routeNum = node.data.label;
      } else {
        routeNum = node.data.parent_labels[0];
      }
      _log_("vue_route/updatebookings 12", routeData)
      this.routeUpdate(node, 0, 0, true)//client needs for update
      const {data} = await this.updateRoutes({

        do: "drive_update",
        base_route: routeNum,
        ...routeData
      });

    }
    ,
    async routeUpdate(node, new_time, old_time, silent) {
      _log_('[updatebookings] START update', new_time, old_time, node, this.data)//
      // const objectSearchStmp = getObjectSearchStmp(node);
      // _log_('getObjectSearchStmp node [updatebookings]', objectSearchStmp)//

      let
          offset = (old_time ? old_time : 0) - (new_time ? new_time : 0)
      let routeData = {}
      if (node.level == 1) {
        routeData.route_asset_id = node.data.route_asset_id
        routeData.bussign = node.data.bussign
        routeData.route_driver_contact_id = node.data.route_driver_contact_id
      }


      if (offset) {
        if (node.data) {
          this.$set(node.data, '_warnings', null)
          this.$set(node.data, '_hasWarning', false)

        }
        _log_('[updatebookings] START update', new_time, old_time, offset)//
        // node.data.starting_time = new_time
        this.deepUpdate(node, {offset: offset * 1, _hasWarning: false})
      }


      let routeNum;
      if (node.data.parent_labels.length == 0) {
        routeNum = node.data.label;
      } else {
        routeNum = node.data.parent_labels[0];
      }

      _log_("vue_route/updatebookings 77", this.list)
      if (!silent) {
        const {data} = await this.updateRoutes({
          bookings: node.data.group,//JSON.stringify(node.data.group),
          do: "update_from_bookings",
          base_route: routeNum,
          ...routeData
        }, true);
      }
      // ++this.clock
      // reOrderTimes
      this.loading = false
    }


    ,
    simple_groupings(data) {
      _log_("simple_groupings", data);
      return data.grouping_choices.filter((grouping_choice) => {
        return data.groupings[grouping_choice].length == 1;
      });
    }
    ,
    groupingInfo_list(data) {
      return data.grouping_choices.filter((grouping_choice) => {

        return (data.groupings[grouping_choice].length == 1) || (
            data.groupings[grouping_choice].length > 1 &&
            (grouping_choice !== "pp_name" ||
                ((data.group_by_parent === "loc_code" ||
                        data.groupings["loc_code"] == null ||
                        data.groupings["loc_code"].length == 1) &&
                    grouping_choice === "pp_name"))
        );
      });
    }
    ,
    full_loc(loc_code) {
      // return loc_code
      return this.locs[loc_code].name + " (" + loc_code + ")";
    }
    ,
    validTimePicker(node) {

      const trip_type = node.data.strip_dir
      // _log_("nodenodenodenodenode", trip_type, node);
      if (trip_type === "ARV") {
        return node.data.group_by_parent === "routeNum";
      } else if (trip_type === "DEP") {
        return (
            node.data.group_by_parent === "routeNum" ||
            (node.parent.data.group_by_parent === "routeNum" &&
                node.data.group_by_parent === "loc_code") ||
            ((node.parent.data.group_by_parent === "loc_code" ||
                    node.parent.data.group_by_parent === "routeNum") &&
                node.data.group_by_parent === "pp_name")
        );
      }
    }
    ,
    toogleTreeExpansion(exp_state) {
      if (!this.$refs.tree) return
      _log_('this.data', this.data, exp_state)
      if (exp_state == 'reset') this.expandNodes = null
      if (exp_state === 'toggle' && this.expandNodes && this.expandNodes.length) {
        this.expandNodes = null
        return
      }
      if (this.data) {
        const allowedExpansions = ["loc_code",
          "routeNum",
          "pp_name"]
        this.expandNodes = []
        this.data.forEach(nd => {
          // _log_('subNd.. nd.routeNum .',  nd.routeNum)
          // if(nd.routeNum === exp_state)
          //   _log_('subNd.. nd.routeNum FOUND.',  nd.routeNum, exp_state,nd)
          if (exp_state !== 'toggle' && nd.routeNum !== exp_state)
            return
          // _log_('subNd..ndnd.', (nd.data ? nd.data.label : nd.label), nd)
          if (nd.group_by_parent && allowedExpansions.indexOf(nd.group_by_parent) >= 0 && nd.children[0] && allowedExpansions.indexOf(nd.children[0].group_by_parent) >= 0) {
            this.expandNodes.push(nd.id)
          }
          nd.children.forEach((subNd) => {
            if (subNd.group_by_parent && allowedExpansions.indexOf(subNd.group_by_parent) >= 0)
                // if (!(subNd.group && subNd.children[0] && subNd.children[0].bk_id)) {
                // _log_('subNd...subNd.0..', (subNd.data ? subNd.data.label : subNd.label), subNd.group_by_parent, subNd.children[0].bk_id, subNd, subNd.children[0])
              if (subNd.children[0] && subNd.children[0].group) {
                // _log_('subNd...subNd.=======2..', this.$refs.tree.getNode(subNd.id), subNd)
                // if (!subNd.children[0].children[0])
                //   this.expandNodes.push(subNd.id)
                // else if (subNd.children[0].children[0].group)
                if (subNd.group_by_parent == "loc_code" && subNd.children[0] && subNd.children[0].group_by_parent == "pp_name") {
                  // if (!subNd.children[0].children)
                  //   this.expandNodes.push(subNd.id)
                  // else if (subNd.children[0].children[0].group)
                  this.expandNodes.push(subNd.id)
                }
                // else if (subNd.children[0].children[0] && subNd.children[0].children[0].group) this.expandNodes.push(subNd.id)
              }
            // }
          })
        })
      }
    }
    ,
    sortData(expandNode) {


      this.data = this.aggr(dflt_grouping_choices, 0, this.list);
      this.data.sort((a, b) => {
        return (
            (a["starting_time"] - b["starting_time"])
        );
      });

      this.toogleTreeExpansion(expandNode || 'toggle')
    }
    ,
  }
  ,
}
;
</script>

<style>
.flushingRoutes {
  filter: brightness(1.5);
}

.unrouted td:first-child, .unrouted th:first-child {
  background: #287f90;
  position: sticky;
  left: 0;
  z-index: 1;
}

.fount-route, .fount-route div.flight_cell {
  border: 2px dashed #812200;
  box-shadow: 0px 0px 2px #c60010;

  //background: red;
}

i.material-icons {
  font-size: 18px;
}

/*.dark div.q-badge.flex {*/
/*  padding: 2px;*/
/*}*/
div.dark .el-link.el-link--default {
  color: #93e0d9;
}

.bookings_composer_header_container {
  padding: 16px 16px 8px 16px !important;
}

.left-timeline-gap {
  width: 130px;
  flex: 0 0 130px;
}

.left-timeline {
  margin-left: -190px;
  width: 130px;
}

.left-timeline div, .left-timeline button {
  float: left;
  width: 130px;
}

.bookings_tree .treeNode_header .right-timeline {
  margin-left: 60px !important;
}

.left-timeline-1 {
  margin-left: -200px;
  width: 100px;
}

.left-timeline-2 {
  /*margin-left: -230px;*/
  width: 100px;
}

.bookings_composer_search_form {
  /*background: #fff;*/
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
  0 3px 1px -2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 10px 8px;
}

.bookings_composer_search_form form {
  display: flex;
  flex-wrap: wrap;
}

.bookings_composer_search_form * {
  display: inline-block;
}

@media (min-width: 500px) {
  .bookings_composer_main_section {
    display: flex;
  }

  .unrouted_bookings_container {
    width: 50%;
    padding: 8px 8px 16px 16px !important;
  }

  .routed_bookings_container {
    width: 50%;
    padding: 8px 16px 16px 8px !important;
  }
}

@media (max-width: 500px) {
  .bookings_composer_main_section {
    display: block;
  }

  .unrouted_bookings_container {
    width: 100%;
    padding: 8px 16px 8px 16px !important;
  }

  .routed_bookings_container {
    width: 100%;
    padding: 8px 16px 16px 16px !important;
  }
}

.flight_cell {
  padding: 0;
  background: rgb(0, 150, 136);
  color: #fff;
  width: 100%;
  height: 70%;
  font-size: 14px;
  justify-content: center;
  cursor: pointer;
}

.empty_cell {
  /* Class for the cells that contain '0' */
  background: none;
  color: #000;
  font-size: 14px;
  justify-content: center;
}

.highlight {
  background: rgb(0, 214, 193) !important;
}

.resort_cell {
  background: none;
  color: whitesmoke;
  font-size: 14px;
}

.no_padding {
  padding: 0 !important;
}

.color_blue {
  color: blue !important;
}

.color_red {
  color: red;
}

div.darkbg, div.darkbg input {
  background-color: #2a5c69;
}

.dark div.el-tree-node {
  background-color: #2a5c69;
  color: antiquewhite;
}

.dark .el-tree-node__content:hover {
  background-color: #447686;
}

.bookings_tree_container {
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
  0 3px 1px -2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  display: flex;
}

.bookings_tree_header,
.unrouted_bookings_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 4px;
  padding-left: 10px;
  padding-right: 10px;
  background: #1a8091;
}

.bookings_tree .treeNode {
  font-size: 12px;
  font-weight: bold;
}

.sunny .el-tree {
  background-color: #ece0cf;
}

.bookings_tree_header .Title,
.unrouted_bookings_header .Title {
  font-size: 20px;
  letter-spacing: 0.005em;
  font-weight: 400;
}

.selected_pax {
  font-size: 18px;
  font-weight: 400;
  padding-right: 4px;
  white-space: nowrap;
}

.bookings_tree_options {
  display: flex;
  padding-top: 8px;
  padding-left: 6px;
}

.bookings_tree_options_groupby {
  padding-right: 6px;
}

.search_option {
  width: fit-content;
  margin-bottom: 5px;
  margin-left: 5px;
}

.treeNode {
  width: 100%;
  padding: 16px 12px;
}

.treeNode_header {
  display: flex;
  justify-content: start;
  align-items: center;
}

/*.treeNode_header > * {*/
/*  margin-right: 8px;*/
/*}*/

.treeNode_header_options {
  display: flex;
  align-items: center;
}

.treeNode_sort_button {
  margin-right: 4px;
}

.treeNode_sort_button * {
  margin: 0;
}

.treeNode_paste_button * {
  margin: 0;
}

.treeNode_Details {
  color: red;
}


.treeNode_info_ticket {
  font-size: 10px;
  padding: 2px;
  box-shadow: 0px 0px 1px;
  margin: 1px;
  display: inline-block;

}

.dark .treeNode_info_ticket {
  color: white;
}

.sunny .treeNode_info_ticket {
  color: #012126;
}

.treeNode_info_group {
  margin-right: 4px;
  padding-right: 4px;
  /* margin-bottom: 12px; */
  font-size: 14px;
  padding-top: 2px;
  display: inline-block;
}

.treeNode_info > .treeNode_info_group:not(:last-of-type) {
  border-right: 0.7px solid;
}

.treeNode_info_groupby_list {
  display: inline-block;
}

.treeNode_groupby_label {
  /* "Group by" label on treeNodes */
  margin: 0;
  color: #777;
  display: inline;
  padding-right: 8px;
  white-space: normal;
}

.treeNode_simple_label {
  /* "Show More..." and "Show Info..." labels on treeNodes */
  margin: 0;
  color: #aaa;
}

.valid_group:hover {
  /*background: #e4e4e4;*/
  border-radius: 4px;
  cursor: pointer;
}

.treeNode_groupingInfo_group_header {
  margin: 0;
  color: #777;
  display: inline-block;
  padding-right: 8px;
  white-space: normal;
  font-size: large;
}

div.treeNode_info button:first-of-type {
  /*background: #fff;*/
  border-color: #409eff;
  color: #e8dcc6;
}

.dark div.treeNode_info_group {
  color: whitesmoke;
}

.full_width {
  width: 100% !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.date_line {
  text-align: center;
  padding: 5px 6px;
  width: auto;
}

/* Element Classes */

.el-form-item {
  margin-right: 20px;
}

.el-form .el-form-item:last-of-type {
  margin-right: 0;
}

.el-form-item__content {
  margin: 0 !important;
}

.el-form-item__label {
  margin-bottom: 0 !important;
}

.el-radio {
  margin-right: 16px !important;
}

.el-radio__input.is-checked + .el-radio__label {
  color: inherit !important;
}

.treeNode .el-date-editor.el-input {
  width: auto !important;
  font-weight: 400 !important;
}

.treeNode .el-input__inner {
  width: 77px;
  padding-right: 0px;
  font-size: 14px;
}

.treeNode .el-input__inner:focus {
  color: #409eff;
  border-color: #409eff;
}

.treeNode .el-input--small .el-input__icon {
  font-weight: 800 !important;
}

.el-tree-node__expand-icon {
  font-size: 20px;
}

.sunny .el-tree-node__expand-icon {
  color: #0e5763;
}

.el-tree-node {
  border-top: rgba(0, 0, 0, 0.12) solid 1px;
  white-space: normal;
}

.el-tree > .is-expanded {
  box-shadow: 0px 0px 2px;
  /*border: rgba(25, 71, 71) solid 2px;*/
  margin: 2px;
}

.is-expanded > .el-tree-node__content {
  cursor: auto !important;
  background-color: rgba(67, 161, 161, 0.2);
}

.is-focusable.is-expanded > .el-tree-node__content {
  cursor: auto !important;
  background-color: rgba(67, 71, 71, 0.2);
}

.el-checkbox__inner {
  width: 20px !important;
  height: 20px !important;
}

.el-checkbox__inner::after {
  border: 2px solid #fff;
  width: 6px;
  height: 12px;
  left: 5px;
  top: 0px;

  box-sizing: content-box;
  content: "";
  border-left: 0;
  border-top: 0;
  position: absolute;
  transform: rotate(45deg) scaleY(0);
  transition: transform 0.15s ease-in 0.05s;
  transform-origin: center;
}

/* Quasar Classes */
.q-table__top {
  padding: 0 !important;
}

.q-table th,
.q-table td {
  padding: 4px 6px;
}

.q-pa-md {
  padding: 0 !important;
}

/*.q-badge {*/
/*  padding: 0 !important;*/
/*}*/

.q-table__sort-icon {
  display: none;
}

/* Others */
.treeNode_info .material-icons,
.treeNode_groupingInfo .material-icons {
  font-size: 14px !important;
}

.dark .el-tree-node:focus > .el-tree-node__content {
  background: #1a8091;
}

.treeNode_Label {
  padding-right: 4px;
  padding-left: 4px;
  white-space: nowrap;
}

.floating-timeline {
  position: absolute;
  top: 0px;
}

.private-route {
  border: 1px solid coral;
}

.warnings-route {
  border-left: solid 2px rgba(255, 0, 0, 0.56);
  background-color: rgba(255, 89, 0, 0.1) !important;
}
</style>


